import decodeJwt from "jwt-decode";
import _ from "lodash";
import moment from "moment-timezone";
import queryString from "query-string";
import { fetchUtils } from "react-admin";
import Resizer from "react-image-file-resizer";
import { getAccessToken, getAuthHeaders } from "./authUtils";
import { apiUrl, enableMpmPlatformOrdering, mytvsuperUrl } from "./constant";
import { convertJsonToRegion, convertRegionToJson } from "./resources/component/region-components";
import { convert_IdToId, convertIdTo_Id, getIMStatus } from "./resources/helper";

// resize posters dim
const portraitSmallSize = { width: 128, height: 186 };
const portraitMediumSize = { width: 200, height: 290 };
const portraitLargeSize = { width: 743, height: 1080 };

const landscapeSmallSize = { width: 324, height: 182 };
const landscapeMediumSize = { width: 615, height: 346 };
const landscapeLargeSize = { width: 1920, height: 1080 };

// resize posters function
const resizeFile = (file, width, height) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      width, // max w
      height, // max h
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob",
      null, // min w
      null, // min h
    );
  });

const httpClient = fetchUtils.fetchJson;

export const blobToJson = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(JSON.parse(reader.result));
    reader.readAsText(blob);
  });
};

//* Convert resBlob to base64
export const blobToData = (blob) => {
  return new Promise((resolve) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result);
    reader.readAsDataURL(blob);
  });
};

// const getBase64FromUrl = async (url) => {
//   const data = await fetch(url);
//   const blob = await data.blob();
//   return new Promise((resolve) => {
//     const reader = new FileReader();
//     reader.readAsDataURL(blob);
//     reader.onloadend = () => {
//       const base64data = reader.result;
//       resolve(base64data);
//     };
//   });
// };

/** Convert to HK time*/

const HKDate = (date) => {
  return date;
  // const time = new Date(date).getTime();
  // const hktime = time - 28800 * 1000;
  // return new Date(hktime);
};
const HKTime = (date) => {
  return date;
  // const time = new Date(date).getTime();
  // const hktime = time + 28800 * 1000;
  // return new Date(hktime);
};

const normalizePlatformWithOrder = (platformWithOrder) => {
  if (!Array.isArray(platformWithOrder)) {
    return [];
  }

  return platformWithOrder.map((item) => ({
    platform: item.platform,
    order: item.order === undefined || item.order === null || String(item.order).trim() === "" ? 0 : Number(item.order),
  }));
};

const normalizePlatformWithOrderForForm = (platformWithOrder) => {
  if (!Array.isArray(platformWithOrder)) {
    return [];
  }

  return platformWithOrder.filter((item) => Number(item.order) !== 0);
};

const normalizeBottomMenuTrackingMapForForm = (trackingMap) => {
  if (!trackingMap || Array.isArray(trackingMap) || typeof trackingMap !== "object") {
    return [];
  }

  return Object.entries(trackingMap).map(([label, value]) => ({
    label,
    value,
  }));
};

const normalizeBottomMenuPayload = (params) => {
  const data = {
    title_tc: params.data.title_tc,
    title_en: params.data.title_en,
    destination: params.data.destination,
    tracking_map: {},
  };

  if (params.data.destination === "WEB") {
    data.universal_link = params.data.universal_link;
    data.universal_link_branch_name = params.data.universal_link_branch_name;
  }

  if (Array.isArray(params.data.tracking_map)) {
    data.tracking_map = params.data.tracking_map.reduce((trackingMap, item) => {
      if (item.label) {
        trackingMap[item.label] = item.value;
      }
      return trackingMap;
    }, {});
  }

  return data;
};

const buildEpgSpecialItemPayload = (formData) => {
  const toUtcIsoString = (value) => (value ? moment(value).utc().toISOString() : null);
  const toDateString = (value) => (value ? moment(value).format("YYYY-MM-DD") : null);
  const repeatWeekday = formData.repeat_weekday || [];
  const data = {
    programme_id: Number(formData.programme_id),
    // Edit responses include the original timing fields; create requests use the selected schedule times.
    original_programme_start_time: toUtcIsoString(formData.original_programme_start_time || formData.start_time),
    original_programme_end_time: toUtcIsoString(formData.original_programme_end_time || formData.end_time),
    programme_title_tc: formData.programme_title_tc,
    programme_title_en: formData.programme_title_en,
    network_code: formData.network_code,
    start_time: toUtcIsoString(formData.start_time),
    end_time: toUtcIsoString(formData.end_time),
    repeat_start_date: toDateString(formData.repeat_start_date),
    repeat_end_date: toDateString(formData.repeat_end_date),
    repeat_weekday: repeatWeekday.map((weekday) => Number(weekday)),
  };

  return data;
};

const normalizeEpgSpecialItemResponse = (item) => ({
  ...item,
  repeat_start_date: item.repeat_start_date ? moment.tz(item.repeat_start_date, "Asia/Hong_Kong").format("YYYY-MM-DD") : item.repeat_start_date,
  repeat_end_date: item.repeat_end_date ? moment.tz(item.repeat_end_date, "Asia/Hong_Kong").format("YYYY-MM-DD") : item.repeat_end_date,
});

const dataProvider = {
  getClipsAutocomplete: async (resource, params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    if (!params.filter["clip_type"]) {
      return { data: [], total: 0 };
    }

    if (!params.filter["name_tc"]) {
      return { data: [], total: 0 };
    }

    const queryObj = {
      sort: "-id",
      page: 1,
      limit: 99999,
    };

    queryObj.where = {
      $and: [
        {
          $expr: {
            $regexMatch: {
              input: { $toString: `$name_tc` },
              regex: ".*" + _.escapeRegExp(params.filter["name_tc"]) + ".*",
              options: "i",
            },
          },
        },
        {
          type: params.filter["clip_type"],
        },
      ],
    };

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/clips?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    var res = [];
    for (const item of json.data) {
      item.name_tc = item.name_tc + " - " + item.clip_id;
      item._id = item.clip_id;

      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getClipsType: async () => {
    const url = `${apiUrl}/clips/type`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    var result = json.data.map((clipType) => {
      return { id: clipType, name: clipType };
    });

    return {
      data: result,
      total: result.length,
    };
  },

  getMenuTreeCategoryById: async (categoryId) => {
    const url = `${apiUrl}/menu-tree/category-id/${categoryId}`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: json,
    };
  },

  getProgrammeByProgrammeId: async (programmeId) => {
    var query = {
      where: {
        programme_id: parseInt(programmeId),
      },
    };

    const url = `${apiUrl}/programmes?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    if (json.data.length > 0) {
      const result = json.data[0];

      return {
        data: convert_IdToId(result),
      };
    } else {
      return { data: null };
    }
  },
  getMpmRowScheduleTypeByType: async (type) => {
    var query = {
      where: {
        type: type,
      },
    };

    const url = `${apiUrl}/mpm-row-schedule-types?query=` + JSON.stringify(query);

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    if (json.data.length > 0) {
      const result = json.data[0];

      return {
        data: convert_IdToId(result),
      };
    } else {
      return { data: null };
    }
  },

  createImage: async (formData) => {
    var data = {};

    data["type"] = formData.type;
    data["platform"] = formData.platform;
    data["image_base64"] = await blobToData(formData.image_base64.rawFile);

    const url = `${apiUrl}/images`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(render),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateImage: async (id, formData) => {
    var data = {};

    data["type"] = formData.type;
    data["platform"] = formData.platform;
    data["image_base64"] = await blobToData(formData.image_base64.rawFile);

    const url = `${apiUrl}/images/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(render),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  getKeyValueByKey: async (key) => {
    var query = {
      where: {
        key: key,
      },
    };

    const url = `${apiUrl}/key-values?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const keyValue = json.data[0];

    return {
      data: convert_IdToId(keyValue),
    };
  },

  getImageByNameAndPlatform: async (name, platform) => {
    var query = {
      where: {
        type: name,
        platform: platform,
      },
    };

    const url = `${apiUrl}/images?query=` + JSON.stringify(query);

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json.data.length > 0) {
      data = json.data[0];
    }

    return {
      data: data,
    };
  },

  getMpmPageByCategoryId: async (categoryId) => {
    var query = {
      where: {
        category_id: parseInt(categoryId),
      },
    };

    const url = `${apiUrl}/mpm-pages?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const page = json.data[0];

    return {
      data: convert_IdToId(page),
    };
  },
  getMpmRowTemplatesByLayouts: async () => {
    var query = {
      // where: {
      //   layout: {
      //     $in: params,
      //   },
      // },
      sort: "name",
      limit: 1000,
    };

    const url = `${apiUrl}/mpm-row-templates?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getMpmRowTagAutocomplete: async (params) => {
    if (!params.filter["tag_type"] || !params.filter["name_tc"]) {
      return {
        data: [],
        total: 0,
      };
    }

    var query = {
      where: {
        $or: [
          {
            $and: [
              {
                type: params.filter["tag_type"],
              },
              {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$name_tc` },
                    regex: ".*" + _.escapeRegExp(params.filter["name_tc"]) + ".*",
                    options: "i",
                  },
                },
              },
            ],
          },
          {
            $and: [
              {
                type: params.filter["tag_type"],
              },
              {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$name_en` },
                    regex: ".*" + _.escapeRegExp(params.filter["name_tc"]) + ".*",
                    options: "i",
                  },
                },
              },
            ],
          },
        ],
      },
    };

    const url = `${apiUrl}/tags?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      delete Object.assign(item, { ["id"]: item["tag_id"] })["_id"];
    }

    return {
      data: json.data,
      total: json.total,
    };
  },
  searchProgrammesByKeyword: async (params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    var query = {
      page: 1,
      limit: 999999,
      where: {
        $or: [
          {
            $expr: {
              $regexMatch: {
                input: { $toString: `$programme_id` },
                regex: ".*" + _.escapeRegExp(params.filter["name_tc"]) + ".*",
                options: "i",
              },
            },
          },
          {
            $expr: {
              $regexMatch: {
                input: { $toString: `$name_tc` },
                regex: ".*" + _.escapeRegExp(params.filter["name_tc"]) + ".*",
                options: "i",
              },
            },
          },
        ],
      },
    };

    const url = `${apiUrl}/programmes?query=` + JSON.stringify(query);

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.name_tc = item.name_tc + " - " + item.programme_id;
      item._id = item.programme_id;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  searchMpmPagesByKeyword: async (params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    const keyword = params.filter["name_tc"] || params.filter["name_en"];
    if (!keyword) {
      return { data: [], total: 0 };
    }

    var query = {
      page: 1,
      limit: 999999,
      where: {
        $or: [
          {
            $expr: {
              $regexMatch: {
                input: { $toString: `$id` },
                regex: ".*" + _.escapeRegExp(keyword) + ".*",
                options: "i",
              },
            },
          },
          {
            $expr: {
              $regexMatch: {
                input: { $toString: `$name_tc` },
                regex: ".*" + _.escapeRegExp(keyword) + ".*",
                options: "i",
              },
            },
          },
          {
            $expr: {
              $regexMatch: {
                input: { $toString: `$name_en` },
                regex: ".*" + _.escapeRegExp(keyword) + ".*",
                options: "i",
              },
            },
          },
        ],
      },
    };

    const url = `${apiUrl}/mpm-pages?query=` + JSON.stringify(query);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      const pageId = item.id !== undefined && item.id !== null ? item.id : item._id;
      item._id = pageId;
      if (item.name_tc) {
        item.name_tc = item.name_tc + " - " + pageId;
      }
      if (item.name_en) {
        item.name_en = item.name_en + " - " + pageId;
      }
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getTagTypes: async () => {
    const url = `${apiUrl}/tags/type`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: json.data.map((p) => ({ id: p, name: p })),
      total: json.data.length,
    };
  },

  getPermissionList: async () => {
    const url = `${apiUrl}/roles/permissions`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: json.map((p) => ({ id: p, name: p })),
      total: json.length,
    };
  },

  getPreviewSlot: async (type, previewDate) => {
    //NOTE: previewDate is moment object

    //https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Date/toISOString
    //It always in format YYYY-MM-DDTHH:mm:ss.sssZ, and zero UTC. So, it doesn't matter if previewDate is in UTC+8 or UTC+0 timezone
    var previewDateString = previewDate.toISOString();

    // const { page, perPage } = params.pagination;
    // const { field, order } = params.sort;
    // const queryObj = {
    //   sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
    //   page: page,
    //   limit: perPage,
    // };

    // queryObj.where = { type: params.filter.type };
    // queryObj.where = { type: params.filter.type };

    // const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/mpm-row-schedules/preview?type=${type}&previewDate=${previewDateString}`;

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };

    // return {
    //   data: json,
    //   total: json.length,
    // };
  },

  getSlots: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };
    const filterKeys = Object.keys(params.filter);

    if (filterKeys.length !== 0) {
      const filter = [];

      let expr;
      let type = { type: params.filter["type"] };
      // if (params.filter["type"].length !== 0) {
      //   type = { type: params.filter["type"] };
      // }
      expr = { slot_id: parseInt(params.filter["slot_id"]) };
      filter.push(expr);
      filter.push(type);
      queryObj.where = { $and: filter };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/mpm-row-schedules?query=${query}`;

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.portrait_poster_custom = item.portrait_poster;
      item.landscape_poster_custom = item.landscape_poster;
      item.region = convertJsonToRegion(item);
    }
    // return { data: [], total: 1 };
    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListHotSearch: async (resource, params) => {
    // const { page, perPage } = params.pagination;
    // const { field, order } = params.sort;
    var where = {};
    if (params.filter.profile_class) {
      where["profile_class"] = params.filter.profile_class;
    }

    if (params.filter.search) {
      where["search"] = { $regex: params.filter.search, $options: "i" };
    }
    if (params.filter.enabled) {
      where["enabled"] = params.filter.enabled;
    }

    const queryObj = {
      where: where,
      sort: "order",
      page: 1,
      limit: 99999,
    };

    // const filterKeys = Object.keys(params.filter);
    // if (filterKeys.length !== 0) {
    //   const filter = [];
    //   filterKeys.forEach((key) => {
    //     let expr;
    //     switch (typeof params.filter[key]) {
    //       case "string": {
    //         if (key == "tags") {
    //           expr = { tags: params.filter[key] };
    //         } else {
    //           expr = {
    //             $expr: {
    //               $regexMatch: {
    //                 input: { $toString: `$${key}` },
    //                 regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
    //                 options: "i",
    //               },
    //             },
    //           };
    //         }

    //         break;
    //       }
    //       default: {
    //         if (key == "tags") {
    //           expr = { tags: params.filter[key] };
    //         } else {
    //           expr = { key: params.filter[key] };
    //         }
    //       }
    //     }
    //     filter.push(expr);
    //   });
    //   queryObj.where = { $and: filter };
    // }
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/hot-searchs?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getSpecialPrograms: async (params) => {
    //1. Get all programmes belong to this AdGroup
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    queryObj.where = {
      is_sprog: true,
    };

    const url = `${apiUrl}/programmes?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getCanvasAdPrograms: async (params) => {
    //1. Get all programmes not call Canvas AD
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    queryObj.where = {
      call_canvas_ad: false,
    };

    const url = `${apiUrl}/programmes?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getAdGroupPrograms: async (params) => {
    //1. Get all programmes belong to this AdGroup
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    const url = `${apiUrl}/ads-adgroups/${params.filter.id}?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    json = json.programmes;

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getAdGroupsProgramsSearch: async (params) => {
    var tagIds = [];
    if (params.filter.tags) {
      for (const tag of params.filter.tags) {
        if (tag && tag.tag_value) {
          tagIds.push(tag.tag_value);
        }
      }
    }

    if (tagIds.length == 0 && !params.filter.programme_id) {
      return {
        data: [],
        total: 0,
      };
    }

    //1. Get all programmes
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var whereArr = [];
    if (tagIds.length > 0) {
      whereArr.push({
        tags: {
          $all: tagIds,
        },
      });
    }
    if (params.filter.programme_id) {
      whereArr.push({ programme_id: parseInt(params.filter.programme_id) });
    }
    queryObj.where = {
      $or: whereArr,
    };

    const url = `${apiUrl}/programmes?query=` + JSON.stringify(queryObj);
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    //2. Get all adGroups that programmes belong to
    var programmeIds = json.data.map((d) => d.programme_id);

    const query = programmeIds;

    const url2 = `${apiUrl}/ads-adgroups/programme_ids?ids=` + JSON.stringify(query);
    const response = await httpClient(url2, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    //3. Merge 1 & 2 data
    for (const item of json.data) {
      for (const d of response.json.data) {
        if (d.programme_ids.programme_id == item.programme_id) {
          item.adgroup_name = d.name;
          item.adgroup_start_date = d.start_date;
          item.adgroup_end_date = d.end_date;
          break;
        }
      }
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getChannelNoListWithPreviewTime: async (params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var query = {};
    if (params.filter.channel_no) {
      query["channel_no"] = parseInt(params.filter.channel_no);
    }
    if (params.filter.network_code) {
      query["network_code"] = params.filter.network_code;
    }

    queryObj.where = query;

    const url = `${apiUrl}/channels/preview?query=` + JSON.stringify(queryObj) + `&preview_time=${params.filter.preview_time}&show_all=${params.filter.show_all}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getChannelNoList: async () => {
    const queryObj = {
      sort: "channel_no",
      page: 1,
      limit: 99999,
    };

    const url = `${apiUrl}/channel-no-list?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  fetchTrafficLogNetworkCode: async () => {
    const url = `${apiUrl}/traffic-log/network-code`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const result = json[0].values.map((obj) => obj.network_code);
    return { data: result, total: result.length };
  },

  getChannelList: async (params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var query = {};
    if (params.filter.channel_no) {
      query["channel_no"] = parseInt(params.filter.channel_no);
    }
    if (params.filter.network_code) {
      query["network_code"] = params.filter.network_code;
    }

    queryObj.where = query;

    const url = `${apiUrl}/channels?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.region = convertJsonToRegion(item);

      item.made_for_kid = false;
      if (item.profile_class.includes("kids")) {
        item.made_for_kid = true;
      }
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getIconPackTypes: async () => {
    const url = `${apiUrl}/im-icon-pack-info`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.length,
    };
  },

  getIconPackTypeById: async (id) => {
    const { data } = await dataProvider.getIconPackTypes();

    const iconPackType = data.find((item) => item.id === id);

    return {
      data: iconPackType,
    };
  },

  getPaidIconPackByIds: async (ids) => {
    const queryObj = {
      id: ids,
    };

    const query = queryString.stringify(queryObj);
    const url = `${apiUrl}/im-icon-list/paid-icon-list?${query}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getListIMPaidIconPacks: async (resource, params) => {
    const queryObj = {};

    if (params.filter.id) {
      queryObj.id = params.filter.id;
    }
    if (params.filter.name) {
      queryObj.name = params.filter.name;
    }
    if (params.filter.type) {
      queryObj.type = params.filter.type;
    }
    if (typeof params.filter.enabled === "boolean") {
      queryObj.enabled = params.filter.enabled;
    }

    const query = queryString.stringify(queryObj);
    const url = `${apiUrl}/im-icon-list/paid-icon-list?${query}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const { data: iconPackTypes } = await dataProvider.getIconPackTypes();
    for (const item of json) {
      const iconPackType = iconPackTypes.find((info) => info.id === item.type);
      item.type_name = iconPackType.name;
    }

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getFreeIconPackType: async () => {
    const { data } = await dataProvider.getIconPackTypes();

    const freeIconPackType = data.find((item) => item.is_pay === false);

    return {
      data: freeIconPackType,
    };
  },

  getPaidIconPackTypes: async () => {
    const { data } = await dataProvider.getIconPackTypes();

    const paidIconPackTypes = data.filter((item) => item.is_pay === true);

    return {
      data: paidIconPackTypes,
    };
  },

  getListIMIcons: async (resource, params) => {
    //Get Free Icon Pack Type ID
    const freeIconPackType = await dataProvider.getFreeIconPackType();
    const freeIconPackTypeId = freeIconPackType.data.id;

    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
      where: {
        type: freeIconPackTypeId,
      },
    };

    const url = `${apiUrl}/im-icons?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  updateEpisodeOrder: async (reset, order) => {
    const url = `${apiUrl}/episodes/order?reset=${reset}`;

    const data = {
      order: order,
    };

    var { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getIMIconsByPackTypeId: async (packTypeId) => {
    const queryObj = {
      page: 1,
      limit: 999999,
      where: {
        type: packTypeId,
      },
    };

    const url = `${apiUrl}/im-icons?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListChannelCategory: async ({ filter } = {}) => {
    const { name_tc, name_en } = filter || {};

    const url = `${apiUrl}/channel-categories`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    //Filter by name_tc and name_en
    if (name_tc) {
      json = json.filter((item) => item.name_tc.toLowerCase().includes(name_tc.toLowerCase()));
    }
    if (name_en) {
      json = json.filter((item) => item.name_en.toLowerCase().includes(name_en.toLowerCase()));
    }

    //Sort by created_at DESC
    json.sort((a, b) => new Date(b.created_at) - new Date(a.created_at));

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getListChannelCategoriesOrderPlatforms: async () => {
    const url = `${apiUrl}/channel-categories-order/platforms`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const data = json.map((item) => ({
      id: item,
      title: item,
    }));

    return {
      data: data,
      total: data.length,
    };
  },

  getListChannelCategoryOrdering: async ({ filter }) => {
    const { platform } = filter || {};

    //platform is required for channel category ordering, if platform is not provided, return empty list
    if (!platform) {
      return {
        data: [],
        total: 0,
      };
    }

    const url = `${apiUrl}/channel-categories-order/${platform}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getListEpg: async (params) => {
    console.log("getListEpg params", params);

    const filter = params.filter || {};
    if (!filter.ref_date || !filter.network_code) {
      return {
        data: [],
        total: 0,
      };
    }

    const queryObj = {
      network_code: filter.network_code,
      ref_date: moment(filter.ref_date).format("YYYY-MM-DD"),
    };

    const query = queryString.stringify(queryObj);

    const url = `${apiUrl}/epg?${query}`;

    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const epgList = json[0] && json[0].epg ? json[0].epg : [];
    const epgRecords = epgList.map((epgItem) => ({
      ...epgItem,
      epg_item_id: epgItem.id,
      // EPG ids may be duplicated, while react-admin retains records by id between filter changes.
      // Use a fresh UI id to prevent stale EPG rows from appearing.
      id: `${epgItem.id}-${Math.random().toString(36).slice(2)}`,
    }));

    return {
      data: convert_IdToId(epgRecords),
      total: epgRecords.length,
    };
  },

  getListEpgEdit: async (params) => {
    console.log("getListEpgEdit params", params);

    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var query = {};
    if (params.filter.programme_id) {
      query["original_programme_id"] = parseInt(params.filter.programme_id);
    }
    if (params.filter.name_tc) {
      query["original_name_tc"] = { $regex: params.filter.name_tc, $options: "i" };
    }

    queryObj.where = query;

    const url = `${apiUrl}/epg-item-replacement?query=` + JSON.stringify(queryObj);

    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListBottomMenu: async () => {
    const url = `${apiUrl}/bottom-menu`;

    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.data.length,
    };
  },

  getOneBottomMenu: async (params) => {
    const url = `${apiUrl}/bottom-menu/${params.id}`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    const data = convert_IdToId(json.data ?? json);
    data.tracking_map = normalizeBottomMenuTrackingMapForForm(data.tracking_map);

    return {
      data,
    };
  },

  updateBottomMenuOrder: async (id, order) => {
    const url = `${apiUrl}/bottom-menu/order/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify({ order }),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getListLiveToContentSchedules: async (params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    const filter = [];
    const { network_code, target_epg_programme_id, type, status } = params.filter || {};

    if (network_code) {
      filter.push({ network_code });
    }

    if (target_epg_programme_id) {
      filter.push({ target_epg_programme_id: Number(target_epg_programme_id) });
    }

    if (type) {
      filter.push({ type });
    }

    if (status) {
      filter.push({ status });
    }

    if (filter.length !== 0) {
      queryObj.where = { $and: filter };
    }

    const url = `${apiUrl}/live-to-content-schedules?query=${JSON.stringify(queryObj)}`;
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListEpgSpecialItems: async (params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page,
      limit: perPage,
    };
    const { network_code, programme_id, status } = params.filter || {};
    const filter = [];

    if (network_code) {
      filter.push({ network_code });
    }

    if (programme_id) {
      filter.push({ programme_id: Number(programme_id) });
    }

    if (status) {
      filter.push({ status });
    }

    if (filter.length) {
      queryObj.where = { $and: filter };
    }

    const { json } = await httpClient(`${apiUrl}/epg-special-items?query=${JSON.stringify(queryObj)}`, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data).map(normalizeEpgSpecialItemResponse),
      total: json.total,
    };
  },

  createEpgSpecialItem: async (params) => {
    const data = buildEpgSpecialItemPayload(params.data);

    const { json } = await httpClient(`${apiUrl}/epg-special-items`, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOneEpgSpecialItem: async (params) => {
    const { json } = await httpClient(`${apiUrl}/epg-special-items/${params.id}`, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: normalizeEpgSpecialItemResponse(convert_IdToId(json)),
    };
  },

  updateEpgSpecialItem: async (params) => {
    const { json } = await httpClient(`${apiUrl}/epg-special-items/${params.id}`, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(buildEpgSpecialItemPayload(params.data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  buildLiveToContentScheduleBody: async (data = {}) => {
    const formatTime = (time) => {
      if (!time) {
        return "";
      }

      const formattedTime = moment(String(time), ["HHmm", "HH:mm", "HH:mm:ss"], true);
      return formattedTime.isValid() ? formattedTime.format("HH:mm:ss") : String(time);
    };

    const formatDate = (date) => (date ? moment.tz(date, "Asia/Hong_Kong").format("YYYY-MM-DD") : "");

    const toNumberOrEmpty = (value) => {
      if (value === undefined || value === null || value === "") {
        return "";
      }

      return Number(value);
    };

    const networkCode = data.network_code || "";
    const portraitPoster = data.portrait_poster_base64?.rawFile ? await blobToData(data.portrait_poster_base64.rawFile) : data.portrait_poster || "";
    const landscapePoster = data.landscape_poster_base64?.rawFile ? await blobToData(data.landscape_poster_base64.rawFile) : data.landscape_poster || "";

    const body = {
      network_code: networkCode,
      type: data.type || "",
      name_tc: data.name_tc || "",
      name_en: data.name_en || "",
      start_time: formatTime(data.start_time),
      end_time: formatTime(data.end_time),
      destination_id: data.destination_id ? data.destination_id.toString() : "",
      target_epg_programme_id: toNumberOrEmpty(data.target_epg_programme_id),
      landscape_poster: landscapePoster,
      portrait_poster: portraitPoster,
      position: data.position || "",
      description_tc: data.description_tc || "",
      description_en: data.description_en || "",
      start_date: formatDate(data.start_date),
      end_date: formatDate(data.end_date),
    };

    const channelQuery = {
      where: {
        network_code: networkCode,
      },
    };
    const channelUrl = `${apiUrl}/channels?query=${JSON.stringify(channelQuery)}`;
    const { json: channelJson } = await httpClient(channelUrl, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    if (!channelJson.data?.[0]?.channel_no) {
      throw new Error(`Cannot find channel_no for network_code: ${networkCode}`);
    }

    body.channel_no = Number(channelJson.data[0].channel_no);

    if (data.version_type) {
      body.version_type = data.version_type;
    }

    return body;
  },

  enrichBulkLiveToContentSchedule: async (data = {}) => {
    const type = data.type || "";

    if (!data.destination_id) {
      throw new Error(`Missing destination_id for ${type || "unknown"} content`);
    }

    let contentMetadata = {};

    if (type === "programme") {
      const { data: programme } = await dataProvider.getProgrammeByProgrammeId(data.destination_id);
      contentMetadata = {
        name_tc: programme?.name_tc,
        name_en: programme?.name_en,
        landscape_poster: programme?.image?.landscape_medium,
        portrait_poster: programme?.image?.portrait_medium,
      };
    } else if (type === "episode") {
      const { data: episodes } = await dataProvider.getList("episodes", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "episode_no", order: "ASC" },
        filter: { episode_id: Number(data.destination_id) },
      });
      const episode = episodes?.[0];
      contentMetadata = {
        name_tc: episode?.name_tc,
        name_en: episode?.name_en,
        landscape_poster: episode?.image?.large,
        portrait_poster: episode?.image?.large,
      };
    } else if (type === "clip") {
      const { data: clips } = await dataProvider.getList("clips", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "ASC" },
        filter: { clip_id: data.destination_id.toString() },
      });
      const clip = clips?.[0];
      contentMetadata = {
        name_tc: clip?.name_tc,
        name_en: clip?.name_en,
        landscape_poster: clip?.image?.landscape_large,
        portrait_poster: clip?.image?.portrait_large,
      };
    } else if (type === "page") {
      const { data: pages } = await dataProvider.getList("mpm-pages", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "ASC" },
        filter: { _id: data.destination_id.toString() },
      });
      const page = pages?.[0];
      contentMetadata = {
        name_tc: page?.name_tc,
        name_en: page?.name_en,
        landscape_poster: page?.image?.landscape_large || page?.image?.landscape_medium,
        portrait_poster: page?.image?.portrait_large || page?.image?.portrait_medium,
      };
    } else if (type === "live") {
      const { data: channels } = await dataProvider.getList("channels", {
        pagination: { page: 1, perPage: 1 },
        sort: { field: "id", order: "ASC" },
        filter: { network_code: data.destination_id.toString() },
      });
      const channel = channels?.[0];
      contentMetadata = {
        name_tc: channel?.name_tc,
        name_en: channel?.name_en,
        landscape_poster: channel?.image?.landscape_large || channel?.landscape_poster,
        portrait_poster: channel?.image?.portrait_large || channel?.portrait_poster,
      };
    }

    return {
      ...data,
      name_tc: contentMetadata.name_tc,
      name_en: contentMetadata.name_en,
      landscape_poster: contentMetadata.landscape_poster,
      portrait_poster: contentMetadata.portrait_poster,
    };
  },

  saveLiveToContentSchedule: async (params, method = "POST") => {
    const body = await dataProvider.buildLiveToContentScheduleBody(params.data || {});

    const url = `${apiUrl}/live-to-content-schedules${method === "PUT" ? `/${params.id}` : ""}`;
    const { json } = await httpClient(url, {
      method,
      headers: await getAuthHeaders(),
      body: JSON.stringify(body),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  emergencyEndLiveToContentSchedule: async (id, data) => {
    const { json } = await httpClient(`${apiUrl}/live-to-content-schedules/emergency-end/${id}`, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createBottomMenu: async (params) => {
    const data = normalizeBottomMenuPayload(params);

    const url = `${apiUrl}/bottom-menu`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateBottomMenu: async (params) => {
    const data = normalizeBottomMenuPayload(params);

    const url = `${apiUrl}/bottom-menu/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createLiveToContentSchedule: async (params) => dataProvider.saveLiveToContentSchedule(params),

  updateLiveToContentSchedule: async (params) => dataProvider.saveLiveToContentSchedule(params, "PUT"),

  bulkCreateLiveToContentSchedules: async (schedules) => {
    const enrichedSchedules = await Promise.all(schedules.map((schedule) => dataProvider.enrichBulkLiveToContentSchedule(schedule)));
    const body = {
      schedules: await Promise.all(enrichedSchedules.map((schedule) => dataProvider.buildLiveToContentScheduleBody(schedule))),
    };

    const { json } = await httpClient(`${apiUrl}/live-to-content-schedules/bulk`, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(body),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getList: async (resource, params) => {
    let originalResource = "";

    if (resource == "bottom-menu") {
      return dataProvider.getListBottomMenu();
    }

    if (resource == "epg-edit-listing") {
      return dataProvider.getListEpgEdit(params);
    }

    if (resource == "epg-listing") {
      return dataProvider.getListEpg(params);
    }

    if (resource == "live-to-content-schedules") {
      return dataProvider.getListLiveToContentSchedules(params);
    }

    if (resource == "epg-modification") {
      return dataProvider.getListEpgSpecialItems(params);
    }

    if (resource == "channels-autocomplete-2") {
      return dataProvider.getListChannelsAutocomplete2(params);
    }

    if (resource == "channels-autocomplete-by-network-code") {
      return dataProvider.getListChannelsAutocomplete2(params);
    }

    if (resource == "tags-autocomplete-by-tag-id") {
      return dataProvider.getListTagsAutocompleteByTagId(params);
    }

    if (resource == "channel-categories-ordering") {
      return dataProvider.getListChannelCategoryOrdering(params);
    }

    if (resource == "channel-categories-order-platforms") {
      return dataProvider.getListChannelCategoriesOrderPlatforms();
    }

    if (resource == "channel-categories") {
      return dataProvider.getListChannelCategory(params);
    }

    if (resource == "im-icons") {
      return dataProvider.getListIMIcons(resource, params);
    }

    if (resource == "im-paid-icon-packs") {
      return dataProvider.getListIMPaidIconPacks(resource, params);
    }
    // if (resource == "icon-pack-info") {
    //   return dataProvider.getIconPackTypes();
    // }

    if (resource == "scoopplus-shorts-channel") {
      return dataProvider.getListScoopPlusShortsChannel();
    }
    if (resource == "traffic-log") {
      return dataProvider.getListTrafficLog(resource, params);
    }

    if (resource == "channel-link-to-vertical-mode") {
      return dataProvider.getListChannelLinkToVerticalMode(resource, params);
    }
    if (resource == "mpm-rows") {
      return dataProvider.getListMpmRows(resource, params);
    }

    if (resource == "menu-tree") {
      return dataProvider.getListMenuTree(resource, params);
    }
    if (resource == "vipo-blacklist") {
      return dataProvider.getListVipoBlacklist(resource, params);
    }
    if (resource == "channel-ordering") {
      return dataProvider.getListChannelOrdering();
    }
    if (resource == "profile-icons" || resource == "kids-profile-icons") {
      return dataProvider.getListProfileIcons(resource, params);
    }

    if (resource == "tags-autocomplete-by-id") {
      return dataProvider.getListTagsAutocomplete(resource, params);
    }

    if (resource == "profiles-preferences" || resource == "kids-profiles-preferences") {
      return dataProvider.getListProfilesPreferences(resource, params);
    }
    if (resource == "im-canned-messages") {
      return dataProvider.getListIMCannedMessages(resource, params);
    }

    if (resource == "im-rooms") {
      return dataProvider.getListIMChatrooms(resource, params);
    }

    if (resource == "episode-preview-schedules") {
      return dataProvider.getEpisodePreviewScheduleList(params);
    }

    if (resource == "subcat-filters") {
      return dataProvider.getSubcatFiltersList(resource, params);
    }

    if (resource == "menu-tree/preview" || resource == "kids-menu-tree/preview") {
      return dataProvider.getMenuTreePreview(resource, params);
    }

    if (resource == "ads-video-categories") {
      return dataProvider.getAdsVideoCategories(params);
    }

    if (resource == "channel-nos") {
      return dataProvider.getChannelNoListWithPreviewTime(params);
    }

    if (resource == "channels") {
      return dataProvider.getChannelList(params);
    }

    if (resource == "special-program-programs") {
      return dataProvider.getSpecialPrograms(params);
    }

    if (resource == "canvas-ad-programs") {
      return dataProvider.getCanvasAdPrograms(params);
    }

    if (resource == "ads-adgroups-programs") {
      return dataProvider.getAdGroupPrograms(params);
    }

    if (resource == "ads-adgroups-programs-search") {
      return dataProvider.getAdGroupsProgramsSearch(params);
    }
    if (resource == "mpm-row-tag-autocomplete") {
      return dataProvider.getMpmRowTagAutocomplete(params);
    }
    if (resource == "tags/type") {
      return dataProvider.getTagTypes();
    }
    if (resource == "permissions") {
      return dataProvider.getPermissionList();
    }

    if (resource == "push-notifications") {
      return dataProvider.getListNotifications(resource, params);
    }

    if (resource == "events") {
      return dataProvider.getListEvent(resource, params);
    }

    if (resource == "categories") {
      return dataProvider.getListCategories(resource);
    }
    if (resource == "editorial-types") {
      return dataProvider.getListEditorial(resource, params);
    }
    if (resource == "event-type") {
      return dataProvider.getListEventType();
    }
    if (resource == "mcdn-appnames") {
      return dataProvider.getListMCDNAppNames();
    }

    if (resource == "hot-searchs" || resource == "kids-hot-searchs") {
      return dataProvider.getListHotSearch(resource, params);
    }
    if (resource == "import-requests") {
      return dataProvider.getListImportRequest(resource, params);
    }

    // if (resource == "mpm") {
    //   return dataProvider.getPreviewSlot(resource, params);
    // }
    // if (resource == "okbuy") {
    //   return dataProvider.getPreviewOkBuySlot(resource, params);
    // }
    // if (resource == "sponsor") {
    //   return dataProvider.getPreviewSponsorSlot(resource, params);
    // }
    // if (resource == "horserace1") {
    //   return dataProvider.getPreviewHorseRace1(resource, params);
    // }
    // if (resource == "horserace2") {
    //   return dataProvider.getPreviewHorseRace2(resource, params);
    // }
    if (resource == "episode-ordering") {
      return dataProvider.getListEpisodeOrdering(params);
    }
    if (resource == "episodes") {
      return dataProvider.getListEpidosePage(resource, params);
    }

    if (resource == "episodes-autocomplete") {
      return dataProvider.getListEpisodeAutoComplete(params);
    }

    if (resource == "slots") {
      return dataProvider.getSlots(resource, params);
    }

    if (resource == "programmes-autocomplete") {
      return dataProvider.searchProgrammesByKeyword(params);
    }

    if (resource == "mpm-page-autocomplete") {
      return dataProvider.searchMpmPagesByKeyword(params);
    }

    if (resource == "im-canned-messages-autocomplete") {
      return dataProvider.searchCannedMessagesByKeyword(params);
    }

    if (resource == "programme-overwrite-poster-module") {
      return dataProvider.getProgrammeOverwritePosterModuleList(resource, params);
    }

    if (resource == "editorials-autocomplete") {
      if (Object.keys(params.filter).length == 0) {
        return { data: [], total: 0 };
      }
      resource = "mpm-row-schedule-types";
      originalResource = "editorials-autocomplete";
    }

    if (resource == "mpm-page-autocomplete") {
      if (Object.keys(params.filter).length == 0) {
        return { data: [], total: 0 };
      }
      resource = "mpm-pages";
      originalResource = "mpm-page-autocomplete";
    }

    if (resource == "emarsys-title") {
      originalResource = resource;
      resource = "mpm-pages";
    }

    if (resource == "page-row-paths") {
      resource = "mpm-pages";
      originalResource = "page-row-paths";
    }

    if (resource == "clips-autocomplete") {
      return dataProvider.getClipsAutocomplete(resource, params);
    }

    if (resource == "vodlives-autocomplete") {
      if (Object.keys(params.filter).length == 0) {
        return { data: [], total: 0 };
      }
      resource = "vod-lives";
    }

    if (resource == "vod-live-testing-data") {
      originalResource = resource;
      resource = "vod-lives";
      return await dataProvider.getVodLiveTestingDataList(resource, params);
    }

    if (resource == "tags-checkbox") {
      return dataProvider.getMany(resource, params);
    }

    if (resource == "channels-autocomplete") {
      if (Object.keys(params.filter).length == 0) {
        return { data: [], total: 0 };
      }
      resource = "channels";
      originalResource = "channels-autocomplete";
    }

    if (resource == "key-value-by-quality") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-event") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-platform") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-drm") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-coding") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "clips-type") {
      return dataProvider.getClipsType();
    }

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      if (originalResource == "channels-autocomplete") {
        item.name_tc = item.name_tc + " - " + item.network_code;
        item._id = item.network_code;
      }
      if (originalResource == "editorials-autocomplete") {
        item.name = item.name + " - " + item.type;
        item._id = item.type;
      }

      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getVodLiveTestingDataList: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };
    const filterKeys = Object.keys(params.filter);
    // if (filterKeys.length !== 0) {
    const filter = [];

    // filter out status = 4
    filter.push({
      status: {
        $ne: 4,
      },
    });

    filterKeys.forEach((key) => {
      let expr;
      switch (typeof params.filter[key]) {
        case "string": {
          if (key == "tags") {
            expr = { tags: params.filter[key] };
          } else {
            expr = {
              $expr: {
                $regexMatch: {
                  input: { $toString: `$${key}` },
                  regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                  options: "i",
                },
              },
            };
          }

          break;
        }
        default: {
          if (key == "tags") {
            expr = { tags: params.filter[key] };
          } else {
            expr = { key: params.filter[key] };
          }
        }
      }
      filter.push(expr);
    });
    queryObj.where = { $and: filter };
    // }
    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  updateChannelOrder: async (allChannelIds) => {
    var data = {
      order: allChannelIds,
    };

    const url = `${apiUrl}/channels/update/order`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  getProgrammeOverwritePosterModuleList: async (resource, params) => {
    if (resource == "programme-overwrite-poster-module") {
      resource = "programme-overwrite-posters";
    }

    const { page, perPage } = params.pagination;

    const sortString = ((params) => {
      if (params.sort && params.sort.field != "order") {
        const { field, order } = params.sort;
        return (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field;
      } else {
        return "-created_at";
      }
    })(params);

    const queryObj = {
      sort: sortString,
      page: page,
      limit: perPage,
    };
    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }
    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getListImportRequest: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };
    const filter = [{ resource: "programme" }];
    queryObj.where = { $and: filter };

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/import-requests?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getListMCDNAppNames: async () => {
    const queryObj = {
      page: 1,
      limit: 999999,
    };

    const filter = [{ key: "mcdn_appname" }];
    queryObj.where = { $and: filter };

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/key-values?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getListEpisodeAutoComplete: async (params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    const queryArr = [];

    if (params.filter.programme_id) {
      queryArr.push({
        programme_id: params.filter.programme_id,
      });
    }

    if (params.filter.episode_no) {
      const orArr = [
        {
          name_tc: {
            $regex: params.filter.episode_no,
            $options: "i",
          },
        },
        {
          name_en: {
            $regex: params.filter.episode_no,
            $options: "i",
          },
        },
      ];

      const isInteger = /^\d+$/.test(params.filter.episode_no);
      if (isInteger) {
        orArr.push({ episode_no: parseInt(params.filter.episode_no) });
      }

      queryArr.push({ $or: orArr });
    }

    if (queryArr.length > 0) {
      queryObj.where = { $and: queryArr };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/episodes?query=${query}`;

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      const arr = [];
      if (item.name_tc) arr.push(item.name_tc);
      arr.push(item.episode_no);
      // if (item.desc_tc) arr.push(item.desc_tc.length > 15 ? item.desc_tc.substring(0, 15) + "..." : item.desc_tc);
      item.name_tc = arr.join(" - ");

      item._id = item.episode_id;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getEpisodeByEpisodeId: async (programmeId, episodeId) => {
    const queryObj = {
      where: {
        $and: [
          {
            programme_id: programmeId,
          },
          { episode_id: episodeId },
        ],
      },
    };
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/episodes?query=${query}`;

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    var data;
    if (json.data.length > 0) {
      data = json.data[0];
    }

    return {
      data: convert_IdToId(data),
    };
  },

  getEpisodeByEpisodeNo: async (programmeId, episodeNo) => {
    const queryObj = {
      where: {
        $and: [
          {
            programme_id: programmeId,
          },
          { episode_no: episodeNo },
        ],
      },
    };
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/episodes?query=${query}`;

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    var data;
    if (json.data.length > 0) {
      data = json.data[0];
    }

    return {
      data: convert_IdToId(data),
    };
  },

  getAllTagsList: async (params) => {
    // const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: 1,
      limit: 999999,
    };
    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }
    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/tags?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getAllArtistsList: async (params) => {
    // const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: 1,
      limit: 9999999,
    };
    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }
    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/artists?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },

  getEpisodePreviewScheduleList: async (params) => {
    let json;

    const { page, perPage } = params.pagination;

    const { order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + "programme_id",
      page: page,
      limit: perPage,
    };

    const url = `${apiUrl}/episode-preview-schedules?query=${JSON.stringify(queryObj)}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      item.id = item._id;

      if (Array.isArray(item.episode_no)) {
        item.episode_list = item.episode_no.join(",");
      } else {
        item.episode_list = item.episode_no;
      }

      if (Array.isArray(item.platform)) {
        item.platform = item.platform.join(",");
      }

      res.push(item);
    }

    return {
      data: res,
      total: json.total,
    };
  },

  getSubcatFiltersList: async (resource, params) => {
    let json;

    const { page, perPage } = params.pagination;

    const { order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + "category_tag_id",
      page: page,
      limit: perPage,
    };
    const filterKeys = Object.keys(params.filter);

    const filter = [];

    // use for /tags
    filter.push({ type: "category" });

    if (filterKeys.length !== 0) {
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
    }

    queryObj.where = { $and: filter };

    // "/subcat-filters/category" Cannot get all cats. change to use "/tags?query={"where":{"type":"category"}}"
    // const url = `${apiUrl}/subcat-filters/category?query=${JSON.stringify(queryObj)}`;
    const url = `${apiUrl}/tags?query=${JSON.stringify(queryObj)}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      // item.id = item.category_tag_id;
      item.id = item.tag_id;
      res.push(item);

      // delete Object.assign(item, { ["id"]: item["category_tag_id"] })["category_tag_id"];
    }

    return {
      data: res,
      total: json.total,
    };
  },

  getMenuTreePreview: async (resource, params) => {
    //Kids requires both general & kids
    var url = `${apiUrl}/menu-tree/preview`;
    if (params.filter.profile_class == "general") {
      url += `?profile_class=${params.filter.profile_class}`;
    }

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getAdsVideoCategories: async (params) => {
    const profileClass = params?.filter?.profile_class === "general" ? "general" : "kids";
    let url = `${apiUrl}/menu-tree/preview`;
    if (profileClass === "general") {
      url += `?profile_class=general`;
    }
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    const searchText = (params.filter?.name_tc || "").toLowerCase();
    const ids = Array.isArray(params.ids) ? params.ids : null;
    const map = new Map();

    for (const previewItem of json) {
      for (const parent of previewItem.menu_tree || []) {
        if (parent && parent.category_id !== undefined && parent.category_id !== null) {
          const id = parent.category_id;
          const name = parent.name_tc || parent.name_en || "Category";
          map.set(id, { id, name_tc: `${name} (${id})` });
        }

        for (const child of parent?.categories || []) {
          if (child && child.category_id !== undefined && child.category_id !== null) {
            const id = child.category_id;
            const name = child.name_tc || child.name_en || "Category";
            map.set(id, { id, name_tc: `${name} (${id})` });
          }
        }
      }
    }

    let data = Array.from(map.values());
    if (searchText) {
      data = data.filter((item) => item.name_tc.toLowerCase().includes(searchText) || String(item.id).includes(searchText));
    }
    if (ids) {
      data = data.filter((item) => ids.includes(item.id));
    }

    return {
      data,
      total: data.length,
    };
  },

  getListEpisodeOrdering: async (params) => {
    const searchParams = new URLSearchParams();
    searchParams.append("id", params.filter.programme_id);
    searchParams.append("asc", false);

    const url = `${apiUrl}/episodes/order?${searchParams.toString()}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json) {
      if (Array.isArray(item["is_preview"])) {
        item["is_preview"] = translatePlatformArray(item["is_preview"]);
      } else {
        item["is_preview"] = "n/a";
      }

      item.nameWithEpisodeNo = item.name_tc + " - " + item.episode_no;

      //Add back programme_id for episode ordering, as it is needed for update episode ordering
      item.programme_id = params.filter.programme_id;
    }

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getListEpidosePage: async (resource, params) => {
    const { page, perPage } = params.pagination;
    // const { field, order } = params.sort;

    const queryObj = {
      // sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      sort: "-order,-episode_no",
      page: page,
      limit: perPage,
    };

    if (params.filter.programme_id) {
      queryObj.where = { programme_id: parseInt(params.filter.programme_id) };
    }
    if (params.filter.episode_id) {
      queryObj.where = { episode_id: params.filter.episode_id };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/episodes?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    for (const item of json.data) {
      if (Array.isArray(item["is_preview"])) {
        item["is_preview"] = translatePlatformArray(item["is_preview"]);
      } else {
        item["is_preview"] = "n/a";
      }

      item.nameWithEpisodeNo = item.name_tc + " - " + item.episode_no;
    }
    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getListCategories: async (resource) => {
    const queryObj = {};
    queryObj.where = { enabled: "true" };

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    const data = [];

    for (const item of json.data) {
      data.push(item.categories);
    }
    for (const i of data[0]) {
      i.id = i.category_id;
      delete Object.assign(i, { id: i["category_id"] })["category_id"];
    }

    return {
      data: data[0],
      total: data[0].length,
    };
  },

  getListCategoriesLevel: async (resource, params) => {
    const queryObj = {};
    queryObj.where = { parent_id: params.filter.parent_id };

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?level=2&query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const i of json.data) {
      i.id = i.category_id;
      delete Object.assign(i, { id: i["category_id"] })["category_id"];
    }

    return {
      data: json.data,
      total: json.data.length,
    };
  },

  getListKeyValues: async (resource, params) => {
    const queryObj = {
      sort: "order",
      page: 1,
      limit: 10,
    };

    if (params.filter.key) {
      queryObj.where = { key: params.filter.key };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/key-values?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListEventType: async () => {
    const queryObj = {
      sort: "order",
      page: 1,
      limit: 10,
    };

    queryObj.where = { key: "event_type" };

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/key-values?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListNotifications: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };
    const start_time = params.filter.start_time;

    let end_time = params.filter.end_time;

    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        delete params.filter.start_time;
        delete params.filter.end_time;
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            expr = {
              $expr: {
                $regexMatch: {
                  input: { $toString: `$${key}` },
                  regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                  options: "i",
                },
              },
            };

            break;
          }
          default: {
            expr = { key: params.filter[key] };
          }
        }
        filter.push(expr);
      });
      if (start_time && !end_time) {
        const d = { scheduled_push_start_date: { $gte: start_time } };
        filter.push(d);
      }
      if (!start_time && end_time) {
        const e = { scheduled_push_start_date: { $lte: end_time } };
        filter.push(e);
      }
      if (start_time && end_time) {
        const b = {
          scheduled_push_start_date: { $gte: start_time, $lte: end_time },
        };
        filter.push(b);
      }
      queryObj.where = { $and: filter };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListEvent: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };
    const start_time = params.filter.start_time;
    let end_time = params.filter.end_time;

    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        delete params.filter.start_time;
        delete params.filter.end_time;
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            expr = {
              $expr: {
                $regexMatch: {
                  input: { $toString: `$${key}` },
                  regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                  options: "i",
                },
              },
            };

            break;
          }
          default: {
            expr = { key: params.filter[key] };
          }
        }
        filter.push(expr);
      });
      if (start_time && !end_time) {
        const d = { start_time: { $gte: start_time } };
        filter.push(d);
      }
      if (!start_time && end_time) {
        const e = { end_time: { $lte: end_time } };
        filter.push(e);
      }
      if (start_time && end_time) {
        const b = {
          start_time: { $gte: start_time },
          end_time: { $lte: end_time },
        };
        filter.push(b);
      }
      queryObj.where = { $and: filter };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListProgramme: async (resource, params) => {
    const queryObj = {
      sort: "-modified_at",
      page: 1,
      limit: 10,
    };
    queryObj.where = { programme_id: parseInt(params.programme_id) };
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListEditorial: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var filters = [];

    const filterKeys = Object.keys(params.filter);
    if (filterKeys.includes("page")) {
      const filterPageName = params.filter["page"];
      const url = `${apiUrl}/mpm-pages/row?type=editorial_pick&filterPageName=${filterPageName}`;
      const { json } = await httpClient(url, {
        headers: await getAuthHeaders(),
      });

      var editorialTypes = [];
      for (const item of json.data) {
        var editorialType = item["ref"].split("/")[1];
        editorialTypes.push(editorialType);
      }

      filters.push({
        type: {
          $in: editorialTypes,
        },
      });

      //Remove page from filterKeys
      const index = filterKeys.indexOf("page");
      if (index > -1) {
        filterKeys.splice(index, 1); // 2nd parameter means remove one item only
      }
    }

    if (filterKeys.length !== 0) {
      filterKeys.forEach((key) => {
        let expr = {
          $expr: {
            $regexMatch: {
              input: { $toString: `$${key}` },
              regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
              options: "i",
            },
          },
        };

        filters.push(expr);
      });
    }

    if (filters.length > 0) {
      queryObj.where = { $and: filters };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/mpm-row-schedule-types?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListEpidose: async (resource, params) => {
    const queryObj = {
      sort: "-modified_at",
      page: 1,
      limit: 100,
    };

    if (params.filter.programme_id) {
      queryObj.where = { programme_id: parseInt(params.filter.programme_id) };
    }
    if (params.filter.episode_id) {
      queryObj.where = { episode_id: params.filter.episode_id };
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/episodes?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getListRowPage: async () => {
    const url = `${apiUrl}/mpm-pages/row?type=editorial_pick`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getOneSlot: async (resource, params) => {
    const url = `${apiUrl}/mpm-row-schedules/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    // backup posters
    if (json.portrait_poster) {
      json.portrait_poster_custom = json.portrait_poster;
    }
    if (json.landscape_poster) {
      json.landscape_poster_custom = json.landscape_poster;
    }

    const start_time = HKTime(json.start_time);
    delete json.start_time;
    json.start_time = start_time;
    //Note: Some data are Uppercase
    json.content_type = json.content_type.toLowerCase();
    json.region = convertJsonToRegion(json);

    // if (json.content_type == "scoopplus_short") {
    //   json.channel_id = json.content_id;
    // }

    return {
      data: convert_IdToId(json),
    };
  },

  getOneEditorial: async (resource, params) => {
    const url = `${apiUrl}/mpm-row-schedule-types/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  getOneCategory: async (resource, params) => {
    const url = `${apiUrl}/categories?query={"where":{"category_id":${params.id}}}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      if (item.categories.category_id == params.id) {
        item.categories.id = item.categories.category_id;
        return {
          data: item.categories,
        };
      }
    }
  },

  updatePaidIconPackStatus: async (paidIconPackId, enabled) => {
    const queryObj = {
      id: paidIconPackId,
      enabled: enabled,
    };
    const query = queryString.stringify(queryObj);
    const url = `${apiUrl}/im-icon-list/paid-icon-list/update-status?${query}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  emergencyStartEndMessageList: async (chatroomId, cannedMessageListId) => {
    const data = {
      _id: cannedMessageListId,
    };
    const url = `${apiUrl}/im-rooms/${chatroomId}/emergency-start-message-list`;
    await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });
  },

  emergencyEndMessageList: async (chatroomId, cannedMessageListId) => {
    const data = {
      _id: cannedMessageListId,
    };
    const url = `${apiUrl}/im-rooms/${chatroomId}/emergency-end-message-list`;
    await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });
  },

  emergencyStartEndChatroom: async (chatroomId, startNow, endNow) => {
    const data = {
      start_now: startNow,
      end_now: endNow,
    };
    const url = `${apiUrl}/im-rooms/${chatroomId}/emergency-start-end`;
    await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });
  },

  getIMRoomProducts: async (productIds) => {
    var queryStrings = [];
    for (const productId of productIds) {
      queryStrings.push(`products=${productId}`);
    }

    const url = `${apiUrl}/im-room-products?${queryStrings.join("&")}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json) {
      //Convert _id to id
      data = convert_IdToId(json);

      if (data) {
        for (const product of data.products) {
          product.open_url = product.is_in_app_url ? "in_app" : "out_app";
          product.onshelf_start_times = [];
          product.onshelf_end_times = [];
          product.live_promote_start_times = [];
          product.live_promote_end_times = [];

          for (const actionLog of product.live_promote_action_log) {
            const d = moment.tz(actionLog.modified_at, "Asia/Hong_Kong");
            const r = d.format("YYYY-MM-DD HH:mm");

            if (actionLog.is_live_promote) {
              product.live_promote_start_times.push(r);
            } else {
              product.live_promote_end_times.push(r);
            }
          }

          for (const actionLog of product.on_shelf_action_log) {
            const d = moment.tz(actionLog.modified_at, "Asia/Hong_Kong");
            const r = d.format("YYYY-MM-DD HH:mm");

            if (actionLog.is_onshelf) {
              product.onshelf_start_times.push(r);
            } else {
              product.onshelf_end_times.push(r);
            }
          }
        }

        //Follow the order of productIds
        data.products = productIds.map((productId) => data.products.find((product) => product.id == productId));
      }
    }

    return data.products;
  },

  getOneIMRooms: async (resource, params) => {
    const url = `${apiUrl}/im-rooms/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json) {
      //Convert _id to id
      data = convert_IdToId(json);

      //Get room_summaries if any
      if (data.room_summaries && Object.keys(data.room_summaries).length > 0) {
        const roomSummary = data.room_summaries;

        //Canned Messages
        // var cannedMessageListSummaries = {};
        // for (const cannedMessageStat of roomSummary.canned_message_stats) {
        //   // const cannedMessageListId = cannedMessageStat.canned_message_list_id;
        //   // const cannedMessageId = cannedMessageStat.canned_message_id;

        //   // const cannedMessageList = data.canned_message_list.find((e) => e.id == cannedMessageListId);
        //   // const cannedMessage = cannedMessageList?.canned_messages.find((e) => e.id == cannedMessageId);

        //   if (!cannedMessageListSummaries[cannedMessageListId]) {
        //     cannedMessageListSummaries[cannedMessageListId] = {
        //       id: cannedMessageListId,
        //       name: cannedMessageList?.name ?? "-",
        //       canned_messages: [],
        //     };
        //   }

        //   cannedMessageListSummaries[cannedMessageListId]["canned_messages"].push({
        //     id: cannedMessageId,
        //     text: cannedMessage?.text ?? "-",
        //     count: cannedMessageStat.count,
        //   });
        // }

        // data.canned_message_list_summaries = Object.values(cannedMessageListSummaries);

        //Icons
        var iconSummaries = [];
        const keys = Object.keys(roomSummary).filter((k) => k.endsWith("icon_stats"));
        for (const k of keys) {
          for (const iconStat of roomSummary[k]) {
            const iconId = iconStat.icon_id;

            if (data.icon_list && data.icon_list.length > 0) {
              const icon = data.icon_list[0].icons.find((e) => e.id == iconId);

              if (icon) {
                iconSummaries.push({
                  // id: iconId,
                  // image_url: iconStat.icon,
                  image_url: icon.image_url ?? icon.purchase_image_info?.unlocked_icon,
                  count: iconStat.count,
                });
              }
            }
          }
        }
        data.icon_summaries = iconSummaries;
      }

      //Add status for convinient
      data.status = getIMStatus(data.start_time, data.end_time);

      //Get all icon
      //Each im-room should have only one icon_list, Move icon_list to anothe variable
      if (data.icon_list && data.icon_list.length > 0) {
        var iconList = data.icon_list[0];

        data["icons"] = iconList.icons;
        data["icon_list_id"] = iconList.id;

        //Add type_name to all icons
        const { data: iconPackTypes } = await dataProvider.getIconPackTypes();
        for (const icon of iconList.icons) {
          //Note: Backward compatible for old icon without type field, assign them to "free" type
          if (!icon.type) {
            icon.type = iconPackTypes.find((pack) => !pack.is_pay).id;
          }

          //Assign type_name to icon
          icon.type_name = iconPackTypes.find((pack) => pack.id == icon.type)?.name || "";
        }

        //Add pack_name to all paid icon
        const packIds = [...new Set(data["icons"].map((icon) => icon.pack_id))];
        if (packIds.length > 0) {
          const { data: paidIconPacks } = await dataProvider.getPaidIconPackByIds(packIds);

          //Assign pack_name to paid icon
          for (const icon of iconList.icons) {
            if (icon.pack_id) {
              icon.pack_name = paidIconPacks.find((pack) => pack.id == icon.pack_id)?.name || "";
            }
          }
        }
      }

      //Add canned_mesasge status for convinient
      if (data.canned_message_list) {
        for (const item of data.canned_message_list) {
          item.status = getIMStatus(item.start_time, item.end_time);
          item.voting_enabled = item.list_type == "vote";
        }
      }

      if (data.products) {
        for (const item of data.products) {
          item.open_url = item.is_in_app_url ? "in_app" : "out_app";
        }

        const productIds = data.products.map((product) => product.id);
        const products = await dataProvider.getIMRoomProducts(productIds);
        data.products = products; //Replace whole products field
      }

      //Backward compatible to type = String
      if (Array.isArray(data.channel_no)) {
        data.channel_no = data.channel_no.join(",");
      }

      //Move stats_config out 1 level
      data = { ...data, ...data["stats_config"] };

      //Move promote_info out 1 level
      data = { ...data, ...data["promote_info"] };
    }

    return {
      data: data,
    };
  },

  getOneIMRoomProducts: async (productId) => {
    const url = `${apiUrl}/im-room-products/${productId}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json) {
      //Convert _id to id
      data = convert_IdToId(json);

      if (data) {
        data.open_url = data.is_in_app_url ? "in_app" : "out_app";
        data.onshelf_start_times = [];
        data.onshelf_end_times = [];
        data.live_promote_start_times = [];
        data.live_promote_end_times = [];

        for (const actionLog of data.live_promote_action_log) {
          const d = moment.tz(actionLog.modified_at, "Asia/Hong_Kong");
          const r = d.format("YYYY-MM-DD HH:mm");

          if (actionLog.is_live_promote) {
            data.live_promote_start_times.push(r);
          } else {
            data.live_promote_end_times.push(r);
          }
        }

        for (const actionLog of data.on_shelf_action_log) {
          const d = moment.tz(actionLog.modified_at, "Asia/Hong_Kong");
          const r = d.format("YYYY-MM-DD HH:mm");

          if (actionLog.is_onshelf) {
            data.onshelf_start_times.push(r);
          } else {
            data.onshelf_end_times.push(r);
          }
        }
      }
    }

    return {
      data: data,
    };
  },

  getOneIMPaidIconPack: async (resource, params) => {
    const queryObj = {
      id: params.id,
    };
    const query = queryString.stringify(queryObj);
    const url = `${apiUrl}/im-icon-list/paid-icon-list?${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    if (json.length == 0) {
      return {
        data: {},
      };
    }

    //Add type_name to the object
    const paidIconPack = json[0];
    const { data: iconPackType } = await dataProvider.getIconPackTypeById(paidIconPack.type);
    paidIconPack.type_name = iconPackType.name;

    for (const icon of paidIconPack.icons) {
      icon.purchase_image_info.animation_icon_tv_file_name = icon.purchase_image_info.animation_icon_tv.split("/").pop();
      icon.purchase_image_info.animation_icon_mobile_file_name = icon.purchase_image_info.animation_icon_mobile.split("/").pop();
    }

    return {
      data: convert_IdToId(paidIconPack),
    };
  },

  getOneChannelCategory: async (params) => {
    const url = `${apiUrl}/channel-categories/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOneEpgEditListing: async (params) => {
    const url = `${apiUrl}/epg-item-replacement/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    json.event_datetime = json.epg_item_event_time;
    json.programme_id = json.replaced_programme_id;
    json.tc_clean_title = json.replaced_name_tc;
    json.en_clean_title = json.replaced_name_en;
    json.episode_no = json.replaced_episode_no;

    if (!json.tc_clean_title && json.title_tc) {
      json.tc_clean_title = json.title_tc;
    }
    if (!json.en_clean_title && json.title_en) {
      json.en_clean_title = json.title_en;
    }

    return {
      data: convert_IdToId(json),
    };
  },

  getOneEpgListing: async (params) => {
    const queryObj = {
      network_code: params.network_code,
      ref_date: params.ref_date ? moment(params.ref_date).format("YYYY-MM-DD") : undefined,
      epg_id: params.id,
    };

    const url = `${apiUrl}/epg/getEpgItem?${queryString.stringify(queryObj)}`;

    // TOOD: Uncomment when GET /epg/getEpgItem API is ready.
    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOne: async (resource, params) => {
    if (resource == "epg-modification") {
      return dataProvider.getOneEpgSpecialItem(params);
    }

    if (resource == "bottom-menu") {
      return dataProvider.getOneBottomMenu(params);
    }

    if (resource == "epg-edit-listing") {
      return dataProvider.getOneEpgEditListing(params);
    }

    if (resource == "epg-listing") {
      return dataProvider.getOneEpgListing(params);
    }

    if (resource == "channel-categories") {
      return dataProvider.getOneChannelCategory(params);
    }

    if (resource == "im-paid-icon-packs") {
      return dataProvider.getOneIMPaidIconPack(resource, params);
    }

    if (resource == "traffic-log") {
      return dataProvider.getOneTrafficLog(resource, params);
    }

    if (resource == "hot-searchs" || resource == "kids-hot-searchs") {
      resource = "hot-searchs";
    }

    if (resource == "profile-icons" || resource == "kids-profile-icons") {
      return dataProvider.getOneProfileIcons(resource, params);
    }

    if (resource == "channel-link-to-vertical-mode") {
      return dataProvider.getOneChannelLinkToVerticalMode(resource, params);
    }

    if (resource == "im-rooms") {
      return dataProvider.getOneIMRooms(resource, params);
    }

    if (resource == "push-notifications") {
      return dataProvider.getOneNotification(resource, params);
    }
    if (resource == "subcat-filters") {
      return dataProvider.getOneSubcatFilters(resource, params);
    }
    if (resource == "subcat-filter-overwrite-list") {
      return dataProvider.getOneSubcatFilterOverwriteList(resource, params);
    }
    if (resource == "subcat-filter-overwrite-create") {
      return dataProvider.getOneSubcatFilterOverwriteCreate(resource, params);
    }
    if (resource == "subcat-filter-overwrite-edit") {
      return dataProvider.getOneSubcatFilterOverwriteEdit(resource, params);
    }

    if (resource == "slots") {
      return dataProvider.getOneSlot(resource, params);
    }

    if (resource == "categories") {
      return dataProvider.getOneCategory(resource, params);
    }

    if (resource == "event-type") {
      return dataProvider.getOneEventType(resource, params);
    }
    if (resource == "mcdn-appname") {
      return dataProvider.getOneMcdnAppName(resource, params);
    }

    if (resource == "channels") {
      return dataProvider.getOneChannel(params);
    }

    if (resource == "programmes") {
      return dataProvider.getOneProgramme(resource, params);
    }

    if (resource == "episodes") {
      return dataProvider.getOneEpisode(resource, params);
    }

    if (resource == "editorial-types") {
      return dataProvider.getOneEditorial(resource, params);
    }
    if (resource == "mpm-rows") {
      return dataProvider.getOneMpmRows(resource, params);
    }

    if (resource == "mpm-home-page" || resource == "kids-mpm-home-page") {
      resource = "mpm-pages";
    }

    if (resource == "emarsys-title") {
      resource = "mpm-pages";
    }

    if (resource == "page-row-paths") {
      resource = "mpm-pages";
    }

    if (resource == "programme-overwrite-poster-module") {
      resource = "programme-overwrite-posters";
    }

    if (resource == "vod-live-testing-data") {
      resource = "vod-lives";
    }

    const url = `${apiUrl}/${resource}/${params.id}`;

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    if (resource == "mpm-rows") {
      //Because ref is keyword, we need to rename it
      delete Object.assign(json, { ref_x: json["ref"] })["ref"];

      if (json["type"] == "recom_personalised") {
        json["type"] = "recommendation";
        json["recommendation_type"] = "recom_personalised";
      } else if (json["type"] == "recom_trendy") {
        json["type"] = "recommendation";
        json["recommendation_type"] = "recom_trendy";
      } else if (json["type"] == "recom_universal") {
        json["type"] = "recommendation";
        json["recommendation_type"] = "recom_universal";
      } else if (json["type"] == "recom_free_preview") {
        json["type"] = "recommendation";
        json["recommendation_type"] = "recom_free_preview";
      } else if (json["type"] == "programme_list") {
        const { data } = await dataProvider.getMany("tags", {
          ids: json["ref_x"],
        });
        json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
      } else if (json["type"] == "editorial_pick") {
        if (json["ref_x"].startsWith("events")) {
          json["type"] = "event";
        }
      } else if (json["type"] == "latest") {
        if (json["filters"] && json["filters"].length > 0) {
          const tagIds = json["filters"][0]["tags"];
          const { data } = await dataProvider.getMany("tags", {
            ids: tagIds,
          });
          json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
        }
      } else if (json["type"] == "top_sv") {
        const { data } = await dataProvider.getMany("tags", {
          ids: json["ref_x"],
        });
        json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
      } else if (json["type"] == "clip_list") {
        const { data } = await dataProvider.getMany("tags", {
          ids: json["ref_x"],
        });
        json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
      }
    } else if (resource == "mpm-pages") {
      json.made_for_kid = false;
      if (json.profile_class.includes("kids")) {
        json.made_for_kid = true;
      }

      json.template = [];
      if (json.is_olympic) {
        json.template.push("is_olympic");
      }
    }

    return {
      data: convert_IdToId(json),
    };
  },

  getMpmRowsOrderByPlatform: async (pageId) => {
    const url = `${apiUrl}/mpm-rows-order-by-platform?page_id=${pageId}`;

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getMpmRowsByPlatform: async (platformId) => {
    const url = `${apiUrl}/mpm-rows-order-by-platform/platform?id=${platformId}`;

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOneSubcatFilters: async (resource, params) => {
    return {
      data: {
        id: parseInt(params.id),
        message: "i have no data about getOneSubcatFilters",
      },
    };
  },

  getOneSubcatFilterOverwriteList: async (resource, params) => {
    const tag = await dataProvider.getTags([params.id]);

    const queryObj = {
      sort: "order",
      where: {
        category_tag_id: parseInt(params.id),
      },
    };

    const url = `${apiUrl}/subcat-filter-overwrite?query=` + JSON.stringify(queryObj);

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json.data.map((item) => {
      item.id = item._id;
    });
    json.id = params.id;
    json.tag = tag.data[0];

    return {
      data: json,
    };
  },

  getOneSubcatFilterOverwriteCreate: async (resource, params) => {
    const tag = await dataProvider.getTags([params.id]);

    const json = {
      id: params.id,
      tag: tag.data[0],
    };

    return {
      data: json,
    };
  },

  getOneSubcatFilterOverwriteEdit: async (resource, params) => {
    const url = `${apiUrl}/subcat-filter-overwrite/${params.id}`;

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    // const json = {
    //   id: params.id,
    //   tag: tag.data[0],
    // };
    // json.tag = tag.data[0];

    return {
      data: convert_IdToId(json),
    };
  },

  getOneMpmRows: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;

    var { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    //Because ref is keyword, we need to rename it

    // if(json["ref"]){
    json.region = convertJsonToRegion(json);
    if (enableMpmPlatformOrdering) {
      json.platform_with_order = normalizePlatformWithOrderForForm(json.platform_with_order);
    } else if (!json.platform && Array.isArray(json.platform_with_order)) {
      json.platform = json.platform_with_order.map((item) => item.platform);
    }
    delete Object.assign(json, { ref_x: json["ref"] })["ref"];
    // }

    if (json["type"] == "recom_personalised") {
      json["type"] = "recommendation";
      json["recommendation_type"] = "recom_personalised";
    } else if (json["type"] == "recom_trendy") {
      json["type"] = "recommendation";
      json["recommendation_type"] = "recom_trendy";
    } else if (json["type"] == "recom_universal") {
      json["type"] = "recommendation";
      json["recommendation_type"] = "recom_universal";
    } else if (json["type"] == "recom_free_preview") {
      json["type"] = "recommendation";
      json["recommendation_type"] = "recom_free_preview";
    } else if (json["type"] == "programme_list") {
      const { data } = await dataProvider.getMany("tags", {
        ids: json["ref_x"],
      });
      json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
    } else if (json["type"] == "editorial_pick") {
      if (json["ref_x"].startsWith("events")) {
        json["type"] = "event";
      }
    } else if (json["type"] == "latest") {
      if (json["filters"] && json["filters"].length > 0) {
        var tagIds = json["filters"][0]["tags"];
        const { data } = await dataProvider.getMany("tags", {
          ids: tagIds,
        });
        json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
      }
    } else if (json["type"] == "top_sv") {
      const { data } = await dataProvider.getMany("tags", {
        ids: json["ref_x"],
      });
      json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
    } else if (json["type"] == "clip_list") {
      const { data } = await dataProvider.getMany("tags", {
        ids: json["ref_x"],
      });
      json["tags"] = data.map((tag) => ({ tag_type: tag.type, tag_value: tag.tag_id }));
    } else if (json["type"] == "scoopplus_short") {
      // json["channel_id"] = json["ref_x"] ? parseInt(json["ref_x"]) : null;
    }

    // also get its parent : mpm-pages
    const pagesResult = await dataProvider._getMpmPagesByRowId(json.id);

    if (pagesResult.data.length > 0) {
      json.page = pagesResult.data[0];
    }

    // if (json.template) {
    //   json.template_1 = json.template;
    //   json.template_2 = json.template;
    //   json.template_3 = json.template;
    // }

    return {
      data: convert_IdToId(json),
    };
  },

  _getMpmPagesByRowId: async (id) => {
    const queryObj = {
      where: {
        rows: id,
      },
    };

    const url = `${apiUrl}/mpm-pages?query=` + JSON.stringify(queryObj);
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return json;
  },

  getOneMenuTree: async (id) => {
    const url = `${apiUrl}/menu-tree/${id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    json.menu_tree = json.menu_tree.map((item, index) => {
      item.id = "lv1_" + index;
      item.region = convertJsonToRegion(item);

      if (item.categories && item.categories.length) {
        item.categories = item.categories.map((item2, index2) => {
          item2.id = "lv2_" + index2;
          item2.region = convertJsonToRegion(item2);

          return item2;
        });
      }
      return item;
    });

    return {
      data: json,
    };
  },

  getOneEpisodeProgramme: async (resource, params) => {
    const queryObj = {
      sort: "-modified_at",
      page: 1,
      limit: 10,
    };
    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        delete params.filter.start_time;
        delete params.filter.end_time;
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            expr = {
              $expr: {
                $regexMatch: {
                  input: { $toString: `$${key}` },
                  regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                  options: "i",
                },
              },
            };

            break;
          }
          default: {
            expr = { key: params.filter[key] };
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/programmes?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getOneEventType: async (resource, params) => {
    const url = `${apiUrl}/key-values/${params.id}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    let data = [];

    for (const value of json.values) {
      data.push({ name: value });
    }
    json.values = data;
    return {
      data: convert_IdToId(json),
    };
  },

  getOneMcdnAppName: (resource, params) => {
    return dataProvider.getOneEventType(resource, params);
  },

  getOneVodLive: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getChannelCopyrightSchedule: async (networkCode) => {
    const searchParams = new URLSearchParams();
    searchParams.append("network_code", networkCode);
    const url = `${apiUrl}/channel-copyright-schedule?${searchParams.toString()}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    //Because server returns content is not the same as what I send to server, I have to convert it back here.
    //For example, server response grouped by "date", each date has a list of "schedules".
    const arr = [];
    for (const item of json) {
      for (const schedule of item.schedules) {
        const startDateTime = moment.tz(schedule.start_time, "Asia/Hong_Kong");
        const startDate = startDateTime.format("YYYY-MM-DD");
        const startTime = startDateTime.format("HH:mm:ss");

        const endDateTime = moment.tz(schedule.end_time, "Asia/Hong_Kong");
        const endDate = endDateTime.format("YYYY-MM-DD");
        const endTime = endDateTime.format("HH:mm:ss");

        const obj = {
          type: schedule.type,
          region: schedule.restricted_region,
          start_date: startDate,
          start_time: startTime,
          end_date: endDate,
          end_time: endTime,
        };

        arr.push(obj);
      }
    }

    return {
      data: arr,
    };
  },

  getOneChannel: async (params) => {
    const url = `${apiUrl}/channels/${params.id}`;
    const { json: channelJson } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    //Get Channel Copyright Schedule
    const networkCode = channelJson.overwrite_network_code ? channelJson.overwrite_network_code : channelJson.network_code;
    const { data: copyrightScheduleData } = await dataProvider.getChannelCopyrightSchedule(networkCode);

    channelJson.restricted_schedule = copyrightScheduleData;

    //get region
    channelJson.region = convertJsonToRegion(channelJson);

    // get the hd_sd
    const profilesMapping = await dataProvider.getManyProfilesMapping("profiles-mapping", {
      bitrate_profile_id: channelJson.bitrate_profile,
      coding_profile_id: channelJson.coding_profile,
      drm_profile_id: channelJson.drm_profile,
    });

    if (profilesMapping.data.data.length >= 1) {
      channelJson.hd_sd = profilesMapping.data.data[0]._id;
    }

    // check made_for_kid by profile_class
    channelJson.made_for_kid = false;
    if (channelJson.profile_class.includes("kids")) {
      channelJson.made_for_kid = true;
    }

    return {
      data: convert_IdToId(channelJson),
    };
  },

  getOneProfileIcons: async (resource, params) => {
    const url = `${apiUrl}/profile-icons/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOneNotification: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    const scheduled_push_start_date = HKTime(json.scheduled_push_start_date);
    delete json.scheduled_push_start_date;
    json.scheduled_push_start_date = scheduled_push_start_date;

    /*
    Make the "prefill_url_content"
    Example:
      programme:
        https://qa-www.mytvsuper.com/tc/programme/hackenleespecial2017_111837/
      episode:
        https://qa-www.mytvsuper.com/tc/programme/enfusionlive_110508/e/302551/
      live_channel:
        https://qa-www.mytvsuper.com/tc/live/604/
    */

    if (json.destination_url.startsWith(mytvsuperUrl + "/")) {
      var prefill_url_content = "";

      //Backward compaitable, old version does not have "tc"
      const slug = json.destination_url.replace(mytvsuperUrl + "/", "").split("/");
      if (slug[0] == "tc") {
        slug.shift();
      }

      //destination_url can be entered manually, so, prefill_url_content can be empty
      if (slug[0] && slug[0] == "live") {
        prefill_url_content = "live_channel";
      }
      if (slug[0] && slug[0] == "programme") {
        if (slug[2] && slug[2] == "e") {
          prefill_url_content = "episode";
        }
        prefill_url_content = "programme";
      }

      json.prefill_url_content = prefill_url_content;

      var title, slug2, programmeId;
      switch (prefill_url_content) {
        case "programme": {
          if (!slug[1]) {
            break;
          }

          title = slug[1];
          slug2 = title.split("_");
          programmeId = slug2[slug2.length - 1];

          const p = await dataProvider.getProgrammeByProgrammeId(programmeId);

          json.title_tc = p.data.name_tc;
          json.title_en = p.data.name_en;
          break;
        }
        case "episode": {
          if (!slug[3]) {
            break;
          }

          title = slug[1];
          slug2 = title.split("_");
          programmeId = slug2[slug2.length - 1];
          const episodeId = slug[3];
          const e = await dataProvider.getEpisodeByEpisodeId(programmeId, episodeId);

          json.title_tc = e.data.name_tc;
          json.title_en = e.data.name_en;
          break;
        }
        case "live_channel": {
          // no api to do this
          break;
        }
        default:
          break;
      }
    }

    return {
      data: convert_IdToId(json),
    };
  },

  getOneProgramme: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    const free_start_time = HKTime(json.free_start_time);
    const free_end_time = HKTime(json.free_end_time);
    const pay_start_time = HKTime(json.pay_start_time);
    const pay_end_time = HKTime(json.pay_end_time);
    const pay_per_programme_start_time = HKTime(json.pay_per_programme_start_time);
    const pay_per_programme_end_time = HKTime(json.pay_per_programme_end_time);

    delete json.free_start_time;
    delete json.free_end_time;
    delete json.pay_start_time;
    delete json.pay_end_time;
    json.free_start_time = free_start_time;
    json.free_end_time = free_end_time;
    json.pay_start_time = pay_start_time;
    json.pay_end_time = pay_end_time;
    json.pay_per_programme_start_time = pay_per_programme_start_time;
    json.pay_per_programme_end_time = pay_per_programme_end_time;
    json.region = convertJsonToRegion(json);
    json.mobile_early_release = false;

    if (typeof json.show_episode_info !== "boolean") {
      json.show_episode_info = true;
    }

    for (const pt of json.platform_time) {
      if (pt.type == "early_release") {
        json.mobile_early_release = true;
        json.mobile_early_release_end_time = HKTime(pt.end_time);
      }

      if (pt.type == "limited_platform") {
        json.limited_platform = pt.platform.join(", ");
      }
    }

    if (json.orientation == "horizontal") {
      json.orientation_portrait = false;
    }

    // get programme/:id/info
    await dataProvider.addProgrammeInfoById(json, params.id);

    return {
      data: convert_IdToId(json),
    };
  },

  getOneEpisode: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    if (Array.isArray(json["is_preview"])) {
      json["is_preview"] = translatePlatformArray(json["is_preview"]);
    } else {
      json["is_preview"] = "n/a";
    }

    for (const pt of json.platform_time) {
      if (pt.type == "early_release") {
        json.app_web_first_start_time = HKTime(pt.start_time);
        json.app_web_first_end_time = HKTime(pt.end_time);
      }

      if (pt.type == "free") {
        json.app_web_free_start_time = HKTime(pt.start_time);
        json.app_web_free_end_time = HKTime(pt.end_time);
      }
    }

    return {
      data: convert_IdToId(json),
    };
  },
  addProgrammeInfoById: async (jsonData, programmeId) => {
    const url2 = `${apiUrl}/programmes/${programmeId}/info`;
    const result = await httpClient(url2, {
      headers: await getAuthHeaders(),
    });
    const json2 = result.json;

    // get default_start_time & default_end_time
    if (json2) {
      if (json2.default_start_time) {
        jsonData.default_start_time = json2.default_start_time;
      }
      if (json2.default_end_time) {
        jsonData.default_end_time = json2.default_end_time;
      }
    }
  },

  getMpmHomepage: async (profileClass) => {
    const url = `${apiUrl}/mpm-pages?query=` + JSON.stringify({ where: { is_homepage: true, profile_class: profileClass } });
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var homepage = json.data[0];

    return {
      data: convert_IdToId(homepage),
    };
  },

  getManyChannelCategoriesOrderByPlatform: async (params) => {
    const data = params.ids.map((id) => {
      return { id: id, title: id };
    });

    return {
      data: convert_IdToId(data),
      total: data.length,
    };
  },

  getManyChannelCategories: async (params) => {
    const { data } = await dataProvider.getListChannelCategory();

    //Filter ids
    const filteredData = data.filter((item) => params.ids.includes(item.id));

    return {
      data: convert_IdToId(filteredData),
      total: filteredData.length,
    };
  },

  getMany: async (resource, params) => {
    var query = "";
    var originalResource = resource;

    if (resource == "channel-categories-order-platforms") {
      return dataProvider.getManyChannelCategoriesOrderByPlatform(params);
    }

    if (resource == "channel-categories") {
      return dataProvider.getManyChannelCategories(params);
    }

    if (resource == "mpm-rows") {
      return dataProvider.getManyMpmRows(resource, params);
    }
    if (resource == "tags-autocomplete-by-tag-id") {
      return dataProvider.getManyTagsAutocompleteByTagId(params);
    }
    if (resource == "tags-autocomplete-by-id") {
      return dataProvider.getManyTagsAutocomplete(resource, params);
    }
    if (resource == "im-canned-messages-autocomplete") {
      return dataProvider.getManyIMCannedMessages(resource, params);
    }

    if (resource == "ads-video-categories") {
      return dataProvider.getAdsVideoCategories(params);
    }

    if (resource == "mpm-row-tag-autocomplete") {
      resource = "tags";
      query = JSON.stringify({ where: { tag_id: { $in: params.ids } } });
    }

    if (resource == "programmes-for-import-requests") {
      return dataProvider.getManyProgrammesForImportRequests(resource, params);
    }
    if (resource == "key-value-by-quality") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-platform") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "clips-type") {
      return dataProvider.getClipsType();
    }
    if (resource == "key-value-by-drm") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "key-value-by-coding") {
      return dataProvider.getManyKeyValue(resource);
    }
    if (resource == "tags-for-show") {
      return dataProvider.getManyTagsForShow(params);
    }

    if (resource == "editorials-autocomplete") {
      resource = "mpm-row-schedule-types";
      query = JSON.stringify({ where: { type: { $in: params.ids } } });
    } else if (resource == "progammes-by-prorgamme_id") {
      resource = "programmes";
      query = JSON.stringify({ page: 1, limit: 99999, where: { programme_id: { $in: params.ids } } });
      // } else if (resource == "categories") {
      //   resource = "categories/";
      //   query = JSON.stringify({ where: { category_id: { $in: params.ids } } });
      //
    } else if (resource == "channels-by-network_code") {
      resource = "channels";
      query = JSON.stringify({ where: { network_code: { $in: params.ids } } });
    } else if (resource == "clip-by-clip_id") {
      resource = "clips";
      query = JSON.stringify({ where: { clip_id: { $in: params.ids } } });
    } else if (resource == "programmes-autocomplete") {
      resource = "programmes";
      query = JSON.stringify({ where: { programme_id: { $in: params.ids } } });
    } else if (resource == "episodes-autocomplete") {
      resource = "episodes";
      query = JSON.stringify({ where: { episode_id: { $in: params.ids } } });
    } else if (resource == "mpm-page-autocomplete") {
      resource = "mpm-pages";
      query = JSON.stringify({ where: { id: { $in: params.ids } } });
    } else if (resource == "clips-autocomplete") {
      resource = "clips";
      query = JSON.stringify({ where: { id: { $in: params.ids } } });
    } else if (resource == "im-canned-messages-autocomplete") {
      resource = "im-canned-messages";
      query = JSON.stringify({ where: { id: { $in: params.ids } } });
    } else if (resource == "tags-checkbox") {
      resource = "tags";
      query = JSON.stringify({
        where: {
          type: "subscription_tag",
          name_en: {
            $not: {
              $regex: "TVOD_",
              $options: "i",
            },
          },
        },
        limit: 99999,
      });
    } else if (resource == "channels-autocomplete-2") {
      return await dataProvider.getManyChannelsAutocomplete2(params);
    } else if (resource == "channels-autocomplete-by-network-code") {
      return await dataProvider.getManyChannelsAutocompleteByNetworkCode(params);
    } else if (resource == "channels-autocomplete") {
      resource = "channels";
      query = JSON.stringify({ where: { id: { $in: params.ids } } });
    } else if (resource == "vodlives-autocomplete") {
      resource = "vod-lives";
      query = JSON.stringify({ where: { id: { $in: params.ids } } });
    } else if (resource == "tags") {
      if (!params.ids) {
        return {
          data: [],
          total: 0,
        };
      }
      if (params.ids.length > 10) {
        query = JSON.stringify({
          limit: params.ids.length,
          where: { tag_id: { $in: params.ids } },
        });
      } else {
        query = JSON.stringify({ where: { tag_id: { $in: params.ids } } });
      }
    } else if (resource == "tags-programme-show") {
      resource = "tags";
      query = JSON.stringify({
        limit: 100,
        where: { tag_id: { $in: params.ids } },
      });
    } else if (resource == "artists") {
      var arr = [];
      for (var id of params.ids) {
        arr.push({ ref_type: id.ref_type, ref_id: id.ref_id });
      }

      query = JSON.stringify({ where: { $or: arr } });
    } else if (resource == "mpm-rows") {
      query = JSON.stringify({ limit: 99999, where: { _id: { $in: params.ids } } });
    } else {
      query = JSON.stringify({ where: { _id: { $in: params.ids } } });
    }

    const url = `${apiUrl}/${resource}?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      if (originalResource == "tags") {
        item.id = item.tag_id;
      } else if (originalResource == "tags-checkbox") {
        item.id = item.tag_id;
      } else if (originalResource == "programmes-autocomplete") {
        item.id = item.programme_id;
        item.name_tc = item.name_tc + " - " + item.programme_id;
      } else if (originalResource == "mpm-page-autocomplete") {
        item.id = item.id !== undefined && item.id !== null ? item.id : item._id;
        if (item.name_tc) {
          item.name_tc = item.name_tc + " - " + item.id;
        }
        if (item.name_en) {
          item.name_en = item.name_en + " - " + item.id;
        }
      } else if (originalResource == "progammes-by-prorgamme_id") {
        item.id = item.programme_id;
      } else if (originalResource == "clip-by-clip_id") {
        item.id = item.clip_id;
      } else if (originalResource == "channels-by-network_code") {
        item.id = item.network_code;
        // }
        // else if (originalResource == "categories") {
        //   item.id = item.category_id;
      } else if (originalResource == "tags-programme-show") {
        item.id = item.tag_id;
      } else if (resource == "editorials-autocomplete") {
        item.id = item.type;
      } else if (originalResource == "mpm-row-tag-autocomplete") {
        item.id = item.tag_id;
      } else {
        delete Object.assign(item, { id: item["_id"] })["_id"];
      }
    }

    var items = json.data;

    //Follow the original orders because using ArrayInput
    if (originalResource == "tags") {
      var result = [];
      for (const id of params.ids) {
        result.push(items.find((item) => item.id == id));
      }
      items = result;
    }

    return {
      data: items,
      total: json.total,
    };
  },

  getManyChannelsAutocomplete2: async (params) => {
    const resource = "channels";
    const query = JSON.stringify({ where: { channel_no: { $in: params.ids } } });

    const url = `${apiUrl}/${resource}?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item._id = item.channel_no;
      item.channel_text = item.name_tc + " - " + item.network_code;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.data.length,
    };
  },

  getManyChannelsAutocompleteByNetworkCode: async (params) => {
    const query = JSON.stringify({ where: { network_code: { $in: params.ids } } });
    const url = `${apiUrl}/channels?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item._id = item.network_code;
      item.channel_text = item.name_tc + " - " + item.network_code;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.data.length,
    };
  },

  getListChannelsAutocomplete2: async (params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    const { page } = params.pagination;
    const { field, order } = params.sort;
    const keyword = params.filter.name_tc || "";
    const query = JSON.stringify({
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: 99999,
      where: {
        $or: ["name_tc", "network_code"].map((field) => ({
          $expr: {
            $regexMatch: {
              input: { $toString: `$${field}` },
              regex: ".*" + _.escapeRegExp(keyword) + ".*",
              options: "i",
            },
          },
        })),
      },
    });
    const url = `${apiUrl}/channels?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.channel_text = item.name_tc + " - " + item.network_code;
      item._id = item.network_code;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getManySubcatFilters: async (resource, params) => {
    const query = { where: { category_tag_id: parseInt(params) } };

    const url = `${apiUrl}/subcat-filters?query=${JSON.stringify(query)}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const j of json.data) {
      j.id = j.sub_category_tag_id;
    }

    return {
      data: json.data,
      total: json.total,
    };
  },

  getManyTagsForShow: async (params) => {
    var query = "";

    if (!params.ids) {
      return {
        data: [],
        total: 0,
      };
    }
    if (params.ids.length > 10) {
      query = JSON.stringify({
        limit: params.ids.length,
        where: { tag_id: { $in: params.ids } },
      });
    } else {
      query = JSON.stringify({ where: { tag_id: { $in: params.ids } } });
    }

    const url = `${apiUrl}/tags?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.id = item.tag_id;
    }

    var items = json.data;

    //Follow the original orders because using ArrayInput
    var result = [];
    for (const id of params.ids) {
      const fetchTag = items.find((item) => item.id == id);
      if (fetchTag) {
        result.push(fetchTag);
      } else {
        result.push({
          id: id,
          // tag_id: null,
          name_en: "##DELETED##",
          name_tc: "##DELETED##",
        });
      }
    }

    items = result;

    return {
      data: items,
      total: json.total,
    };
  },

  getManyProfilesMapping: async (resource, params) => {
    var query = JSON.stringify({
      where: {
        $and: [{ bitrate_profile_id: params.bitrate_profile_id }, { coding_profile_id: params.coding_profile_id }, { drm_profile_id: params.drm_profile_id }],
      },
    });

    const url = `${apiUrl}/${resource}?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: json,
      total: json.total,
    };
  },

  getManyKeyValue: async (resource) => {
    var query = "";
    var originalResource = resource;

    if (resource == "key-value-by-quality") {
      resource = "key-values";
      query = JSON.stringify({ where: { key: { $in: ["quality"] } } });
    }
    if (resource == "key-value-by-event") {
      resource = "key-values";
      query = JSON.stringify({ where: { key: { $in: ["event_type"] } } });
    }
    if (resource == "key-value-by-platform") {
      resource = "key-values";
      query = JSON.stringify({ where: { key: { $in: ["platform"] } } });
    }
    if (resource == "key-value-by-drm") {
      resource = "key-values";
      query = JSON.stringify({ where: { key: { $in: ["drm"] } } });
    }
    if (resource == "key-value-by-coding") {
      resource = "key-values";
      query = JSON.stringify({ where: { key: { $in: ["coding"] } } });
    }

    const url = `${apiUrl}/${resource}?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    let data = [];
    if (originalResource == "key-value-by-event") {
      for (const value of json.data[0].values) {
        data.push({ name: value });
      }
    } else {
      for (const value of json.data[0].values) {
        data.push({ id: value, name: value });
      }
    }

    return {
      data: data,
      total: data.length,
    };
  },

  getManyReference: async (resource, params) => {
    if (resource == "programme-ref") {
      return dataProvider.getManyReferenceProgramme(resource, params);
    }

    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field, //order by _id, modify field name
      page: page,
      limit: perPage,
      where: { [params.target]: params.id },
    };
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
    /*
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;
    const query = {
      sort: JSON.stringify([field, order]),
      range: JSON.stringify([(page - 1) * perPage, page * perPage - 1]),
      filter: JSON.stringify({
        ...params.filter,
        [params.target]: params.id,
      }),
    };
    const url = `${apiUrl}/${resource}?${stringify(query)}`;

    return httpClient(url).then(({ headers, json }) => ({
      data: json,
      total: parseInt(headers.get('content-range').split('/').pop(), 10),
    }));
    */
    //throw new Error('Not Implemented');
  },

  updateEditorialAutoplay: async (resource, params) => {
    const editorialType = params.data.type;
    const autoplay = params.data.autoplay;

    //Get Editorial ID by Type
    const result = await dataProvider.getMpmRowScheduleTypeByType(editorialType);
    const editorialId = result.data.id;

    //Update Editorial Autoplay
    const url = `${apiUrl}/mpm-row-schedule-types/${editorialId}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify({ autoplay: autoplay }),
    });

    return {
      data: json,
    };
  },

  updateSlotOrder: async (params) => {
    const url = `${apiUrl}/mpm-row-schedules/slot?type=${params.type}&slot_id=${params.slot_id}&new_slot_id=${params.new_slot_id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateSlot: async (resource, params) => {
    var data = {};
    data["slot_id"] = parseInt(params.data.slot_id);
    data["type"] = params.data.type;
    data["content_id"] = params.data.content_id ? params.data.content_id.toString() : "";
    data["content_type"] = params.data.content_type;
    data["caption_en"] = null;
    data["caption_tc"] = null;
    data["enabled"] = params.data.enabled;
    data["start_time"] = moment(params.data.start_time);
    data["platform"] = params.data.platform;
    Object.assign(data, convertRegionToJson(params.data.region));

    if (Object.prototype.hasOwnProperty.call(params.data, "portrait_poster_base64")) {
      if (params.data.portrait_poster_base64) {
        data["portrait_poster_base64"] = await blobToData(params.data.portrait_poster_base64.rawFile);
      } else {
        // set to null -> submit a null to delete the poster
        data["portrait_poster_base64"] = null;
      }
    }
    if (Object.prototype.hasOwnProperty.call(params.data, "landscape_poster_base64")) {
      if (params.data.landscape_poster_base64) {
        data["landscape_poster_base64"] = await blobToData(params.data.landscape_poster_base64.rawFile);
      } else {
        // set to null -> submit a null to delete the poster
        data["landscape_poster_base64"] = null;
      }
    }

    if ("programme" == params.data.content_type) {
      if (params.data.caption_en != params.data.programme_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.programme_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("episode" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("live" == params.data.content_type) {
      if (params.data.caption_en != params.data.channel_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.channel_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("vodlive" == params.data.content_type) {
      if (params.data.caption_en != params.data.vodlive_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.vodlive_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("clip" == params.data.content_type) {
      if (params.data.caption_en != params.data.clip_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.clip_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("page" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if (["horse_racecard", "horse_history", "horse_tips"].includes(params.data.content_type)) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("search" == params.data.content_type) {
      data["search_keyword"] = params.data.search_keyword;
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("scoopplus_short" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
      data["content_id"] = params.data.channel_id?.toString() ?? "";
    }

    const url = `${apiUrl}/mpm-row-schedules/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateSubcatFilterOverwriteOrder: async (params) => {
    var data = {
      order: params.data.order,
    };

    const url = `${apiUrl}/subcat-filter-overwrite/${params.id}/order`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updatePoster: async (resource, params) => {
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    let render = {};
    let resDataPortraitSmall = "";
    let resDataPortraitMedium = "";
    let resDataPortraitLarge = "";
    let resDataLandscapeSmall = "";
    let resDataLandscapeMedium = "";
    let resDataLandscapeLarge = "";

    // if (params.data.portrait_small_base64) {
    //   resDataPortraitSmall = await blobToData(params.data.portrait_small_base64.rawFile);
    //   render.portrait_small_base64 = resDataPortraitSmall;
    // }
    // if (params.data.portrait_medium_base64) {
    //   resDataPortraitMedium = await blobToData(params.data.portrait_medium_base64.rawFile);
    //   render.portrait_medium_base64 = resDataPortraitMedium;
    // }
    // if (params.data.portrait_large_base64) {
    //   resDataPortraitLarge = await blobToData(params.data.portrait_large_base64.rawFile);
    //   render.portrait_large_base64 = resDataPortraitLarge;
    // }

    // use resizer
    if (params.data.portrait_large_base64) {
      const pl = params.data.portrait_large_base64.rawFile;
      resDataPortraitSmall = await blobToData(await resizeFile(pl, portraitSmallSize.width, portraitSmallSize.height));
      render.portrait_small_base64 = resDataPortraitSmall;
      resDataPortraitMedium = await blobToData(await resizeFile(pl, portraitMediumSize.width, portraitMediumSize.height));
      render.portrait_medium_base64 = resDataPortraitMedium;
      resDataPortraitLarge = await blobToData(await resizeFile(pl, portraitLargeSize.width, portraitLargeSize.height));
      render.portrait_large_base64 = resDataPortraitLarge;
    }

    // if (params.data.landscape_small_base64) {
    //   resDataLandscapeSmall = await blobToData(params.data.landscape_small_base64.rawFile);
    //   render.landscape_small_base64 = resDataLandscapeSmall;
    // }
    // if (params.data.landscape_medium_base64) {
    //   resDataLandscapeMedium = await blobToData(params.data.landscape_medium_base64.rawFile);
    //   render.landscape_medium_base64 = resDataLandscapeMedium;
    // }
    // if (params.data.landscape_large_base64) {
    //   resDataLandscapeLarge = await blobToData(params.data.landscape_large_base64.rawFile);
    //   render.landscape_large_base64 = resDataLandscapeLarge;
    // }

    // use resizer
    if (params.data.landscape_large_base64) {
      const ll = params.data.landscape_large_base64.rawFile;
      resDataLandscapeSmall = await blobToData(await resizeFile(ll, landscapeSmallSize.width, landscapeSmallSize.height));
      render.landscape_small_base64 = resDataLandscapeSmall;
      resDataLandscapeMedium = await blobToData(await resizeFile(ll, landscapeMediumSize.width, landscapeMediumSize.height));
      render.landscape_medium_base64 = resDataLandscapeMedium;
      resDataLandscapeLarge = await blobToData(await resizeFile(ll, landscapeLargeSize.width, landscapeLargeSize.height));
      render.landscape_large_base64 = resDataLandscapeLarge;
    }

    render.programme_id = parseFloat(params.data.programme_id);
    render.start_time = params.data.start_time;
    render.end_time = params.data.end_time;

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateEvent: async (resource, params) => {
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    let render = {};

    if (params.data.portrait_poster_base64) {
      const resDataPortrait = await blobToData(params.data.portrait_poster_base64.rawFile);
      render.portrait_poster_base64 = resDataPortrait;
    }
    if (params.data.landscape_poster_base64) {
      const resDataLandscape = await blobToData(params.data.landscape_poster_base64.rawFile);
      render.landscape_poster_base64 = resDataLandscape;
    }

    render.title = params.data.title;
    render.type = params.data.key;

    let codes = [];
    let topic = [];
    for (const code of params.data.codes) {
      if (code.sports_event_code && typeof code.sports_event_code == "string") {
        topic = code.sports_event_code.split(",");
      } else {
        topic = code.sports_event_code;
      }

      codes.push({
        sports_topic_code: code.sports_topic_code,
        sports_event_code: topic,
      });
    }

    render.codes = codes;
    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateKeyValue: async (resource, params) => {
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    delete params.data.key;

    const url = `${apiUrl}/${resource}/${params.id}`;
    let values = [];
    if (params.data.values && typeof params.data.values == "string") {
      values = params.data.values.split(",");
    } else {
      values = params.data.values;
    }
    delete params.data.values;
    const render = params.data;
    render.values = values;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateEventType: async (resource, params) => {
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    delete params.data.key;

    const url = `${apiUrl}/key-values/${params.id}`;
    let values = [];
    for (const val of params.data.values) {
      values.push(val.name);
    }

    let render = {};
    render.values = values;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateMcdnAppName: (resource, params) => {
    return dataProvider.updateEventType(resource, params);
  },
  updateHorseRaceData: async (resource, params) => {
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    delete params.data.image_url;
    // delete params.data.race_no;
    let render = params.data;
    if (params.data.image_base64) {
      const resDataimage = await blobToData(params.data.image_base64.rawFile);
      delete params.data.image_base64;
      render.image_base64 = resDataimage;
    }

    let race_no = parseFloat(params.data.race_no);

    render.race_no = race_no;

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateEpisode: async (resource, params) => {
    let render = {};
    render.free_start_time = params.data.free_start_time;
    render.free_end_time = params.data.free_end_time;
    render.pay_start_time = params.data.pay_start_time;
    render.pay_end_time = params.data.pay_end_time;
    render.gold_start_time = params.data.gold_start_time;
    render.gold_end_time = params.data.gold_end_time;
    render.app_web_free_start_time = params.data.app_web_free_start_time;
    render.app_web_free_end_time = params.data.app_web_free_end_time;
    // render.premium_start_time = params.data.premium_start_time;
    // render.premium_end_time = params.data.premium_end_time;
    // render.pay_per_episode_start_time = params.data.pay_per_episode_start_time;
    // render.pay_per_episode_end_time = params.data.pay_per_episode_end_time;
    render.is_preview = params.data.is_preview;
    render.enabled = params.data.enabled;

    render.platform_time = params.data.platform_time;
    for (const pt of render.platform_time) {
      if (pt.type == "free") {
        pt.start_time = params.data.app_web_free_start_time;
        pt.end_time = params.data.app_web_free_end_time;
      } else if (pt.type == "early_release") {
        pt.start_time = params.data.app_web_first_start_time;
        pt.end_time = params.data.app_web_first_end_time;
      }
    }

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(render)),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateAdGroup: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}/programme-id`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params.data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateKidsMenuTree: async (resource, params) => {
    const data = {
      profile_class: params.data.profileClass == "kids" ? ["kids"] : ["general"],
      description: params.data.description,
      start_time: params.data.startTime,
      menu_tree: params.data.menuTree,
    };

    const url = `${apiUrl}/menu-tree/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateIMPaidIconPacks: async (resource, params) => {
    const icons = await Promise.all(
      params.data.icons.map(async (icon, idx) => ({
        _id: icon.id,
        order: idx,
        enabled: true, //always true
        purchase_image_info: {
          name: icon.purchase_image_info.name,
          animation_icon_tv: icon.purchase_image_info.animation_icon_tv_file ? await blobToJson(icon.purchase_image_info.animation_icon_tv_file.rawFile) : icon.purchase_image_info.animation_icon_tv,
          animation_icon_mobile: icon.purchase_image_info.animation_icon_mobile_file ? await blobToJson(icon.purchase_image_info.animation_icon_mobile_file.rawFile) : icon.purchase_image_info.animation_icon_mobile,
          locked_icon: icon.purchase_image_info.locked_icon_file ? await blobToData(icon.purchase_image_info.locked_icon_file.rawFile) : icon.purchase_image_info.locked_icon,
          unlocked_icon: icon.purchase_image_info.unlocked_icon_file ? await blobToData(icon.purchase_image_info.unlocked_icon_file.rawFile) : icon.purchase_image_info.unlocked_icon,
          // animation_icon_tv_file_name: icon.purchase_image_info.animation_icon_tv_file_name,
          // animation_icon_mobile_file_name: icon.purchase_image_info.animation_icon_mobile_file_name,
        },
        delete: icon.delete ?? false,
        // is_used: icon.is_used ?? false,
      })),
    );

    const data = {
      type: params.data.type,
      name: params.data.name,
      icons: icons,
    };

    const url = `${apiUrl}/im-icon-list/paid-icon-list/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateChannelCategories: async (params) => {
    const data = {
      name_tc: params.data.name_tc,
      name_en: params.data.name_en,
    };

    const url = `${apiUrl}/channel-categories/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateEpgEditListing: async (params) => {
    const data = {
      epg_ref_date: params.data.epg_ref_date,
      epg_item_id: Number(params.data.epg_item_id),
      epg_item_event_time: moment.tz(params.data.event_datetime, "Asia/Hong_Kong").format("YYYY-MM-DD HH:mm:ss"),
      epg_network_code: params.data.epg_network_code,
      programme_id: params.data.programme_id,
      episode_no: params.data.episode_no,
    };

    const url = `${apiUrl}/epg-item-replacement/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createEpgListingReplacement: async (params) => {
    const data = {
      epg_ref_date: params.data.epg_ref_date ? moment(params.data.epg_ref_date).format("YYYY-MM-DD") : undefined,
      epg_item_id: Number(params.data.epg_item_id || params.id),
      epg_item_event_time: moment.tz(params.data.event_datetime, "Asia/Hong_Kong").format("YYYY-MM-DD HH:mm:ss"),
      epg_network_code: params.data.epg_network_code,
      programme_id: params.data.programme_id,
      episode_no: params.data.episode_no,
    };

    const url = `${apiUrl}/epg-item-replacement`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  update: async (resource, params) => {
    if (resource == "epg-modification") {
      return dataProvider.updateEpgSpecialItem(params);
    }

    if (resource == "bottom-menu") {
      return dataProvider.updateBottomMenu(params);
    }
    if (resource == "epg-edit-listing") {
      return dataProvider.updateEpgEditListing(params);
    }

    if (resource == "epg-listing") {
      return dataProvider.createEpgListingReplacement(params);
    }

    if (resource == "live-to-content-schedules") {
      return dataProvider.updateLiveToContentSchedule(params);
    }

    if (resource == "channel-categories") {
      return dataProvider.updateChannelCategories(params);
    }

    if (resource == "im-paid-icon-packs") {
      return dataProvider.updateIMPaidIconPacks(resource, params);
    }

    if (resource == "traffic-log") {
      return dataProvider.updateTrafficLog(resource, params);
    }

    // validation:
    if (resource == "programmes") {
      // backend validation (this is supposed not to triggered because has front end validation)
      if ((params.data.start_time && !params.data.end_time) || (!params.data.start_time && params.data.end_time)) {
        throw Error("Please input both overwrite start time and end time");
      }
    }

    if (resource == "kids-menu-tree") {
      return dataProvider.updateKidsMenuTree(resource, params);
    }

    if (resource == "channel-link-to-vertical-mode") {
      return dataProvider.updateChannelLinkToVerticalMode(resource, params);
    }

    if (resource == "im-rooms") {
      return dataProvider.updateIMChatroom(resource, params);
    }

    // proceed:
    if (resource == "mpm-home-page" || resource == "kids-mpm-home-page") {
      resource = "mpm-pages";
    }

    if (resource == "im-canned-messages") {
      return dataProvider.updateIMCannedMessages(resource, params);
    }

    if (resource == "im-icons") {
      return dataProvider.updateIMIcon(resource, params);
    }

    if (resource == "profile-icon-order") {
      return dataProvider.updateProfileIconOrder(resource, params);
    }

    if (resource == "subcat-filters") {
      return dataProvider.updateSubcatFilters(resource, params);
    }
    if (resource == "subcat-filter-overwrite-edit") {
      return dataProvider.updateSubcatFilterOverwrite(params);
    }
    if (resource == "mpm-pages") {
      return dataProvider.updateMpmPages(resource, params);
    }
    if (resource == "ads-adgroups") {
      return dataProvider.updateAdGroup(resource, params);
    }
    if (resource == "mpm-rows") {
      return dataProvider.updateMpmRow(resource, params);
    }
    if (resource == "push-notifications") {
      return dataProvider.updateNotification(resource, params);
    }
    if (resource == "key-values") {
      return dataProvider.updateKeyValue(resource, params);
    }
    if (resource == "event-type") {
      return dataProvider.updateEventType(resource, params);
    }
    if (resource == "mcdn-appname") {
      return dataProvider.updateMcdnAppName(resource, params);
    }
    if (resource == "episodes") {
      return dataProvider.updateEpisode(resource, params);
    }
    if (resource == "channels") {
      return dataProvider.updateChannel(params);
    }
    if (resource == "slots") {
      return dataProvider.updateSlot(resource, params);
    }

    if (resource == "hot-searchs-order") {
      return dataProvider.updateHotSearchOrder(resource, params);
    }

    if (resource == "profile-icons" || resource == "kids-profile-icons") {
      return dataProvider.updateProfileIcon(resource, params);
    }

    if (resource == "events") {
      return dataProvider.updateEvent(resource, params);
    }

    if (resource == "horserace-data") {
      return dataProvider.updateHorseRaceData(resource, params);
    }
    if (resource == "editorial-types") {
      return dataProvider.updateEditorialType(resource, params);
    }
    if (resource == "page-row-paths") {
      return dataProvider.updatePagePath(params);
    }
    if (resource == "mpm-pages") {
      delete params.data.zoneimage_app_en;
      if (params.data.zoneimage_app_en_base64) {
        params.data.zoneimage_app_en_base64 = await blobToData(params.data.zoneimage_app_en_base64.rawFile);
      }
      delete params.data.zoneimage_app_tc;
      if (params.data.zoneimage_app_tc_base64) {
        params.data.zoneimage_app_tc_base64 = await blobToData(params.data.zoneimage_app_tc_base64.rawFile);
      }
      delete params.data.zoneimage_stb_en;
      if (params.data.zoneimage_stb_en_base64) {
        params.data.zoneimage_stb_en_base64 = await blobToData(params.data.zoneimage_stb_en_base64.rawFile);
      }
      delete params.data.zoneimage_stb_tc;
      if (params.data.zoneimage_stb_tc_base64) {
        params.data.zoneimage_stb_tc_base64 = await blobToData(params.data.zoneimage_stb_tc_base64.rawFile);
      }
      delete params.data.zoneimage_web_en;
      if (params.data.zoneimage_web_en_base64) {
        params.data.zoneimage_web_en_base64 = await blobToData(params.data.zoneimage_web_en_base64.rawFile);
      }
      delete params.data.zoneimage_web_tc;
      if (params.data.zoneimage_web_tc_base64) {
        params.data.zoneimage_web_tc_base64 = await blobToData(params.data.zoneimage_web_tc_base64.rawFile);
      }
    }

    if (resource == "hot-searchs" || resource == "kids-hot-searchs") {
      return dataProvider.updateHotSearchs(resource, params);
    }

    if (resource == "canvas-ad-programs") {
      return dataProvider.updateCanvasAdPrograms(params);
    }

    //Delete basic useless params
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;

    if (resource == "vod-live-testing-data") {
      resource = "vod-lives";
    }

    if (resource == "programme-overwrite-posters") {
      return dataProvider.updatePoster(resource, params);
    } else {
      var data = params.data;

      // if (resource == "hot-searchs") {
      //   data = {
      //     search: params.data.search,
      //     enabled: params.data.enabled,
      //   };
      // } else
      if (resource == "programmes") {
        data = {
          enabled: params.data.enabled,
          start_time: HKDate(params.data.start_time),
          end_time: HKDate(params.data.end_time),
          show_offshelf: params.data.show_offshelf,
          use_cloud_image: params.data.use_cloud_image,
          seo_desc_en: params.data.seo_desc_en,
          seo_desc_tc: params.data.seo_desc_tc,
          gold_content: params.data.gold_content,
          is_early_release_for_gold_user: params.data.is_early_release_for_gold_user,
          early_release_for_gold_user_end_time: HKDate(params.data.early_release_for_gold_user_end_time),
          // pay_per_programme_start_time: HKDate(params.data.pay_per_programme_start_time),
          // pay_per_programme_end_time: HKDate(params.data.pay_per_programme_end_time),
        };
      }

      const url = `${apiUrl}/${resource}/${params.id}`;

      const { json } = await httpClient(url, {
        method: "PUT",
        headers: await getAuthHeaders(),
        body: JSON.stringify(data),
      });

      return {
        data: convert_IdToId(json),
      };
    }
  },

  updateUserPassword: async (params) => {
    const data = {
      password: params.data.password,
    };
    const url = `${apiUrl}/users/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateSubcatFilters: async (resource, params) => {
    const data = { order: params.order };

    const url = `${apiUrl}/subcat-filters/${params.id}/order`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateSubcatFilterOverwrite: async (params) => {
    const data = {
      // "category_tag_id": parseInt(params.data.id),
      sub_category_tag_id: parseInt(params.data.sub_category_tag_id),
    };

    const url = `${apiUrl}/subcat-filter-overwrite/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateChannel: async (params) => {
    const data = params.data;

    let resDataPortrait;
    let resDataLandscape;
    let resDisclaimer;
    let resCopyrightPoster;

    //Portrait Poster
    if (data.portrait_poster_base64) {
      resDataPortrait = await blobToData(data.portrait_poster_base64.rawFile); //New
    } else if (data.portrait_poster) {
      resDataPortrait = undefined; //Unchange
    } else {
      resDataPortrait = null; //Remove
    }

    //Landscape Poster
    if (data.landscape_poster_base64) {
      resDataLandscape = await blobToData(data.landscape_poster_base64.rawFile);
    } else if (data.landscape_poster) {
      resDataLandscape = undefined;
    } else {
      resDataLandscape = null;
    }

    //Disclaimer Image
    if (data.disclaimer_image_base64) {
      resDisclaimer = await blobToData(data.disclaimer_image_base64.rawFile);
    } else if (data.disclaimer_image) {
      resDisclaimer = undefined;
    } else {
      resDisclaimer = null;
    }

    //Copyright Poster
    if (data.copyright_poster_base64) {
      resCopyrightPoster = await blobToData(data.copyright_poster_base64.rawFile);
    } else if (data.copyright_poster) {
      resCopyrightPoster = undefined;
    } else {
      resCopyrightPoster = null;
    }

    const profileClass = data.made_for_kid ? ["general", "kids"] : ["general"];
    const locations = {
      allowlist: {
        countries: data.region,
      },
    };

    const bodyObj = {
      start_time: HKDate(data.start_time),
      end_time: HKDate(data.end_time),
      channel_no: data.channel_no,
      network_code: data.network_code,
      name_en: data.name_en,
      name_tc: data.name_tc,
      timeshift: data.timeshift,
      catchup: data.catchup,
      orientation: data.orientation,
      overwrite_network_code: data.overwrite_network_code,
      show_num: data.show_num,
      mcdn_appname: data.mcdn_appname,
      bitrate_profile: data.bitrate_profile,
      coding_profile: data.coding_profile,
      drm_profile: data.drm_profile,
      aspect_ratio: data.aspect_ratio,
      audio_1: data.audio_1,
      audio_2: data.audio_2,
      audio_3: data.audio_3,
      remark: data.remark,
      path: data.path, //Only in update
      enabled: data.enabled,
      locked: data.locked,
      is_default: data.is_default,
      is_dtt: data.is_dtt,
      is_interactive: data.is_interactive,
      is_4k: data.is_4k,
      is_rtc: data.is_rtc,
      show_with_subscription: data.show_with_subscription,
      call_ad: data.call_ad,
      show_in_listing: data.show_in_listing,
      has_flash_sync_u_wall: data.has_flash_sync_u_wall,
      is_whitelist: data.is_whitelist,
      channel_preview: data.channel_preview, //Only in update
      has_im: data.has_im,
      tags: data.tags,
      channel_category_ids: data.channel_category_ids,
      platform: data.platform,
      locations: locations,
      landscape_poster_base64: resDataLandscape,
      portrait_poster_base64: resDataPortrait,
      disclaimer_image_base64: resDisclaimer,
      copyright_poster_base64: resCopyrightPoster,
      listen_copyright_schedules: data.listen_copyright_schedules,
      profile_class: profileClass,
    };

    const url = `${apiUrl}/channels/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(bodyObj),
    });

    if (data.restricted_schedule_updated && Array.isArray(data.restricted_schedule)) {
      const networkCode = data.overwrite_network_code ? data.overwrite_network_code : data.network_code;
      await dataProvider.createChannelCopyrightSchedule(networkCode, data.restricted_schedule);
    }

    return {
      data: convert_IdToId(json),
    };
  },

  approverApproveNotification: async (id) => {
    const url = `${apiUrl}/push-notifications/approve/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  removeVipoData: async (id) => {
    const url = `${apiUrl}/vipo-blacklist/${id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  rejectNotification: async (id) => {
    const url = `${apiUrl}/push-notifications/reject/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  cancelNotification: async (id) => {
    const url = `${apiUrl}/push-notifications/cancel/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateNotification: async (resource, params) => {
    //Delete basic useless params
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.programme;
    delete params.data.channel_id;
    delete params.data.episode_id;
    delete params.data.__v;
    delete params.data.master_message_id;
    delete params.data.tag;

    // push now
    var scheduled_push_start_date = HKDate(params.data.scheduled_push_start_date);
    if (params.data.push_now_toggle) {
      scheduled_push_start_date = moment().toISOString();
    } else {
      // push schedule date validation
      if (moment(scheduled_push_start_date) < moment()) throw new Error("Please input the correct scheduled push start date/ time");
    }
    delete params.data.push_now_toggle;

    const accessToken = await getAccessToken();
    const decodedToken = decodeJwt(accessToken);
    var data = params.data;
    data.modified_by = decodedToken.sub;

    // Photo
    delete params.data.image_url;
    if (params.data.image_base64) {
      if (params.data.image_base64 == "remove") {
        params.data.image_base64 = null;
      } else {
        params.data.image_base64 = await blobToData(params.data.image_base64.rawFile);
      }
    }

    delete data.scheduled_push_start_date;
    data.scheduled_push_start_date = scheduled_push_start_date;

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateHotSearchOrder: async (resource, params) => {
    const url = `${apiUrl}/hot-searchs/${params.hotSearchId}/order`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify({ order: params.newOrder }),
    });

    return {
      data: convert_IdToId(json),
    };
    // }
  },

  updateProfileIconOrder: async (resource, params) => {
    const url = `${apiUrl}/profile-icons/${params.profileIconId}/order`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify({ order: params.newOrder }),
    });

    return {
      data: convert_IdToId(json),
    };
    // }
  },

  updateProfileIcon: async (resource, params) => {
    var seriesIcon = params.data.series_icon;
    if (params.data.series_icon_base64) {
      seriesIcon = await blobToData(params.data.series_icon_base64.rawFile);
    }

    const profileIcons = [];
    if (params.data.profile_icons) {
      for (const item of params.data.profile_icons) {
        if (item.icon_base64) {
          profileIcons.push({
            icon_base64: await blobToData(item.icon_base64.rawFile),
            enabled: item.enabled,
          });
        } else {
          profileIcons.push(convertIdTo_Id(item));
        }
      }
    }

    const data = {
      _id: params.id,
      series_tc: params.data.series_tc,
      series_en: params.data.series_en,
      series_icon: seriesIcon,
      enabled: params.data.enabled,
      show_in_frontend: params.data.show_in_frontend,
      // profile_class: params.data.pc == "kids" ? ["general", "kids"] : ["general"],
      profile_class: params.data.profile_class,
      profile_icons: profileIcons,
    };

    // //Delete basic useless params
    // delete params.data.id;
    // delete params.data.created_at;
    // delete params.data.modified_at;
    // delete params.data.__v;
    // delete params.data.order;
    // delete params.data.icon_url;
    // let icon_base64_main = "";
    // if (params.data.icon_base64) {
    //   icon_base64_main = await blobToData(params.data.icon_base64.rawFile);
    // }
    // delete params.data.icon_base64;
    // for (const item of params.data.profile_icons) {
    //   let icon_base64 = "";
    //   let icon_base64_child = {};
    //   if (item.icon_base64) {
    //     item.icon_base64 = await blobToData(item.icon_base64.rawFile);
    //   }
    //   delete item.name_tc;
    //   delete item.name_en;
    // }
    // // delete params.data.profile_icons;
    // const render = params.data;

    // render.icon_base64 = icon_base64_main;
    const url = `${apiUrl}/profile-icons/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateEditorialType: async (resource, params) => {
    //Delete basic useless params
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    delete params.data.order;
    delete params.data.type;

    // delete params.data.profile_icons;
    const render = params.data;

    const url = `${apiUrl}/mpm-row-schedule-types/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateCanvasAdPrograms: async (resource, params) => {
    const payload = params?.data ?? resource?.data ?? resource ?? {};
    const url = `${apiUrl}/canvas-ad/`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(payload),
    });

    console.log(json)

    return {
      data: {
        id: "canvas-ad",
        ...json,
      },
    };  
  },

  createPoster: async (resource, params) => {
    let render = {};
    // const resDataPortraitSmall = await blobToData(params.data.portrait_small_base64.rawFile);
    // const resDataPortraitMedium = await blobToData(params.data.portrait_medium_base64.rawFile);
    // const resDataPortraitLarge = await blobToData(params.data.portrait_large_base64.rawFile);
    const pl = params.data.portrait_large_base64.rawFile;
    const resDataPortraitSmall = await blobToData(await resizeFile(pl, portraitSmallSize.width, portraitSmallSize.height));
    const resDataPortraitMedium = await blobToData(await resizeFile(pl, portraitMediumSize.width, portraitMediumSize.height));
    const resDataPortraitLarge = await blobToData(await resizeFile(pl, portraitLargeSize.width, portraitLargeSize.height));
    // const resDataLandscapeSmall = await blobToData(params.data.landscape_small_base64.rawFile);
    // const resDataLandscapeMedium = await blobToData(params.data.landscape_medium_base64.rawFile);
    // const resDataLandscapeLarge = await blobToData(params.data.landscape_large_base64.rawFile);
    const ll = params.data.landscape_large_base64.rawFile;
    const resDataLandscapeSmall = await blobToData(await resizeFile(ll, landscapeSmallSize.width, landscapeSmallSize.height));
    const resDataLandscapeMedium = await blobToData(await resizeFile(ll, landscapeMediumSize.width, landscapeMediumSize.height));
    const resDataLandscapeLarge = await blobToData(await resizeFile(ll, landscapeLargeSize.width, landscapeLargeSize.height));

    render.programme_id = parseFloat(params.data.programme_id);
    render.start_time = params.data.start_time;
    render.end_time = params.data.end_time;
    render.portrait_small_base64 = resDataPortraitSmall;
    render.portrait_medium_base64 = resDataPortraitMedium;
    render.portrait_large_base64 = resDataPortraitLarge;
    render.landscape_small_base64 = resDataLandscapeSmall;
    render.landscape_medium_base64 = resDataLandscapeMedium;
    render.landscape_large_base64 = resDataLandscapeLarge;
    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createSlot: async (resource, params) => {
    var data = {};
    data["slot_id"] = parseInt(params.data.slot_id);
    data["type"] = params.data.type;
    data["content_id"] = params.data.content_id ? params.data.content_id.toString() : "";
    data["content_type"] = params.data.content_type;
    data["caption_en"] = null;
    data["caption_tc"] = null;
    data["enabled"] = params.data.enabled;
    data["start_time"] = moment(params.data.start_time);
    data["portrait_poster_base64"] = null;
    data["landscape_poster_base64"] = null;
    data["platform"] = params.data.platform;
    Object.assign(data, convertRegionToJson(params.data.region));

    if (params.data.portrait_poster_base64) {
      data["portrait_poster_base64"] = await blobToData(params.data.portrait_poster_base64.rawFile);
    }
    if (params.data.landscape_poster_base64) {
      data["landscape_poster_base64"] = await blobToData(params.data.landscape_poster_base64.rawFile);
    }

    if ("programme" == params.data.content_type) {
      if (params.data.caption_en != params.data.programme_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.programme_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("episode" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("live" == params.data.content_type) {
      if (params.data.caption_en != params.data.channel_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.channel_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("vodlive" == params.data.content_type) {
      if (params.data.caption_en != params.data.vodlive_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.vodlive_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("clip" == params.data.content_type) {
      if (params.data.caption_en != params.data.clip_name_en) {
        data["caption_en"] = params.data.caption_en;
      }

      if (params.data.caption_tc != params.data.clip_name_tc) {
        data["caption_tc"] = params.data.caption_tc;
      }
    } else if ("page" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if (["horse_racecard", "horse_history", "horse_tips"].includes(params.data.content_type)) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("search" == params.data.content_type) {
      data["search_keyword"] = params.data.search_keyword;
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
    } else if ("scoopplus_short" == params.data.content_type) {
      data["caption_en"] = params.data.caption_en;
      data["caption_tc"] = params.data.caption_tc;
      data["content_id"] = params.data.channel_id?.toString() ?? "";
    }

    const url = `${apiUrl}/mpm-row-schedules`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(render),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createMpmRow: async (resource, params) => {
    var data = {};
    // data["filters"] = [];
    data["name"] = params.data.name;

    // template_3 : size in orientation in loopRow
    if (params.data.template_3) {
      data["template"] = params.data.template_3;
    }

    // template_2 : orientation in loopRow
    else if (params.data.template_2) {
      data["template"] = params.data.template_2;

      // template : default template param
    } else {
      data["template"] = params.data.template;
    }

    data["title_en"] = params.data.title_en;
    data["title_tc"] = params.data.title_tc;
    data["type"] = params.data.type;
    data["num_of_rows"] = params.data.num_of_rows;
    data["parent_page_id"] = params.data.page_id;
    data["start_time"] = params.data.start_time;
    data["end_time"] = params.data.end_time;
    data["seo_desc_tc"] = params.data.seo_desc_tc;
    data["seo_desc_en"] = params.data.seo_desc_en;
    if (enableMpmPlatformOrdering) {
      data["platform_with_order"] = normalizePlatformWithOrder(params.data.platform_with_order);
    } else {
      data["platform"] = params.data.platform;
    }
    Object.assign(data, convertRegionToJson(params.data.region));

    if (params.data.type == "editorial_pick") {
      data["ref"] = "editorial_pick/" + params.data.editorial_type;
    } else if (params.data.type == "recommendation") {
      if (params.data.recommendation_type == "recom_personalised") {
        data["ref"] = "recom_personalised";
        data["type"] = "recom_personalised";
      } else if (params.data.recommendation_type == "recom_trendy") {
        data["ref"] = "recom_trendy";
        data["type"] = "recom_trendy";
      } else if (params.data.recommendation_type == "recom_universal") {
        data["ref"] = "recom_universal";
        data["type"] = "recom_universal";
      } else if (params.data.recommendation_type == "recom_free_preview") {
        data["ref"] = "recom_free_preview";
        data["type"] = "recom_free_preview";
      }
    } else if (params.data.type == "programme_list") {
      // data["show_in_menu"] = params.data.show_in_menu;
      data["free_episodes_only"] = params.data.free_episodes_only;

      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
      if (params.data.page_path && params.data.path) {
        data["path"] = params.data.page_path + params.data.path;
      } else if (params.data.path) {
        data["path"] = params.data.path;
      }
    } else if (params.data.type == "history") {
      data["ref"] = "history";
    } else if (params.data.type == "latest") {
      data["ref"] = "latest";

      var tags = [];
      if (params.data.tags) {
        tags = params.data.tags.map((tag) => tag.tag_value);
        data["filters"] = [
          {
            tags: tags,
            num_of_items: 20,
          },
        ];
      } else {
        data["filters"] = null;
      }
    } else if (params.data.type == "top_sv") {
      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
    } else if (params.data.type == "clip_list") {
      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
    } else if (params.data.type == "episode_list") {
      if (params.data.programme_id) {
        data["ref"] = params.data.programme_id.toString();
      }
    } else if (params.data.type == "event") {
      data["type"] = "editorial_pick";
      data["ref"] = "events/" + params.data.event_type_value;
    } else if (params.data.type == "category_list") {
      data["ref"] = "category_list";
    } else if (params.data.type == "scoopplus_short") {
      data["ref"] = params.data.channel_id?.toString() ?? "";

      if (params.data.page_path && params.data.path) {
        data["path"] = params.data.page_path + params.data.path;
      } else if (params.data.path) {
        data["path"] = params.data.path;
      }
    }

    const url = `${apiUrl}/mpm-rows`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateMpmRowEmarsysTitle: async (param, mpmRow) => {
    const data = {
      path: param.data.path,
    };
    const url = `${apiUrl}/mpm-rows/${mpmRow.id}/path-homepage`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: json,
    };
  },

  updateMpmRow: async (resource, params) => {
    var data = {};
    // data["filters"] = [];
    data["name"] = params.data.name;

    // template_3 : size in orientation in loopRow
    if (params.data.template_3) {
      data["template"] = params.data.template_3;
    }

    // template_2 : orientation in loopRow
    else if (params.data.template_2) {
      data["template"] = params.data.template_2;

      // template : default template param
    } else {
      data["template"] = params.data.template;
    }

    data["title_en"] = params.data.title_en;
    data["title_tc"] = params.data.title_tc;
    data["type"] = params.data.type;
    data["num_of_rows"] = params.data.num_of_rows;
    data["parent_page_id"] = params.data.page_id;
    data["start_time"] = params.data.start_time;
    data["end_time"] = params.data.end_time;
    data["seo_desc_tc"] = params.data.seo_desc_tc;
    data["seo_desc_en"] = params.data.seo_desc_en;
    if (enableMpmPlatformOrdering) {
      data["platform_with_order"] = normalizePlatformWithOrder(params.data.platform_with_order);
    } else {
      data["platform"] = params.data.platform;
    }
    Object.assign(data, convertRegionToJson(params.data.region));

    data["ref"] = ""; //Reset

    if (params.data.type == "editorial_pick") {
      data["ref"] = "editorial_pick/" + params.data.editorial_type;
    } else if (params.data.type == "recommendation") {
      if (params.data.recommendation_type == "recom_personalised") {
        data["ref"] = "recom_personalised";
        data["type"] = "recom_personalised";
      } else if (params.data.recommendation_type == "recom_trendy") {
        data["ref"] = "recom_trendy";
        data["type"] = "recom_trendy";
      } else if (params.data.recommendation_type == "recom_universal") {
        data["ref"] = "recom_universal";
        data["type"] = "recom_universal";
      } else if (params.data.recommendation_type == "recom_free_preview") {
        data["ref"] = "recom_free_preview";
        data["type"] = "recom_free_preview";
      }
    } else if (params.data.type == "programme_list") {
      // data["show_in_menu"] = params.data.show_in_menu;
      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
      data["free_episodes_only"] = params.data.free_episodes_only;
    } else if (params.data.type == "history") {
      data["ref"] = "history";
    } else if (params.data.type == "latest") {
      data["ref"] = "latest";

      var tags = [];
      if (params.data.tags) {
        tags = params.data.tags.map((tag) => tag.tag_value);
        data["filters"] = [
          {
            tags: tags,
            num_of_items: 20,
          },
        ];
      } else {
        data["filters"] = null;
      }
    } else if (params.data.type == "top_sv") {
      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
    } else if (params.data.type == "clip_list") {
      if (params.data.tags) {
        data["ref"] = params.data.tags.map((tag) => tag.tag_value);
      }
    } else if (params.data.type == "episode_list") {
      if (params.data.programme_id) {
        data["ref"] = params.data.programme_id.toString();
      }
    } else if (params.data.type == "event") {
      data["type"] = "editorial_pick";
      data["ref"] = "events/" + params.data.event_type_value;
    } else if (params.data.type == "category_list") {
      data["ref"] = "category_list";
    } else if (params.data.type == "scoopplus_short") {
      data["ref"] = params.data.channel_id?.toString() ?? "";
    }

    const url = `${apiUrl}/mpm-rows/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      // body: JSON.stringify(render),
      body: JSON.stringify(data),
    });

    // rename 'ref' to 'ref_x'
    if (Object.prototype.hasOwnProperty.call(json, "ref")) {
      json.ref_x = json.ref;
      delete json.ref;
    }

    return {
      data: convert_IdToId(json),
    };
  },

  createIMPaidIconPack: async (resource, params) => {
    const data = {
      name: params.data.name,
      type: params.data.type,
    };

    const url = `${apiUrl}/im-icon-list/paid-icon-list`;

    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createChannelCategory: async (params) => {
    const data = {
      name_tc: params.data.name_tc,
      name_en: params.data.name_en,
    };

    const url = `${apiUrl}/channel-categories`;

    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  create: async (resource, params) => {
    if (resource == "epg-modification") {
      return dataProvider.createEpgSpecialItem(params);
    }

    if (resource == "bottom-menu") {
      return dataProvider.createBottomMenu(params);
    }

    if (resource == "epg-listing") {
      return dataProvider.createEpgListingReplacement(params);
    }

    if (resource == "channel-categories") {
      return dataProvider.createChannelCategory(params);
    }

    if (resource == "im-paid-icon-packs") {
      return dataProvider.createIMPaidIconPack(resource, params);
    }

    if (resource == "hot-searchs" || resource == "kids-hot-searchs") {
      return dataProvider.createHotSearch(resource, params);
    }

    if (resource == "profiles-preferences" || resource == "kids-profiles-preferences") {
      return dataProvider.createProfilesPreference(resource, params);
    }

    if (resource == "channel-link-to-vertical-mode") {
      return dataProvider.createChannelLinkToVerticalMode(resource, params);
    }
    if (resource == "im-canned-messages") {
      return dataProvider.createIMCannedMessage(resource, params);
    }

    if (resource == "im-icons") {
      return dataProvider.createIMIcon(resource, params);
    }

    if (resource == "im-rooms") {
      return dataProvider.createIMChatroom(resource, params);
    }

    if (resource == "episode-preview-schedules") {
      return dataProvider.createEpisodePreviewSchedules(params);
    }

    if (resource == "live-to-content-schedules") {
      return dataProvider.createLiveToContentSchedule(params);
    }

    if (resource == "special-program-programs") {
      resource = "programmes/is-sprog";
    }

    if (resource == "import-requests") {
      return dataProvider.createImportRequests(resource, params);
    }

    if (resource == "mpm-pages") {
      return dataProvider.createMpmPages(resource, params);
    }

    if (resource == "mpm-rows") {
      return dataProvider.createMpmRow(resource, params);
    }

    if (resource == "channels") {
      return dataProvider.createChannel(params);
    }
    if (resource == "push-notifications") {
      return dataProvider.createNotification(resource, params);
    }
    if (resource == "key-values") {
      return dataProvider.createKeyValue(resource, params);
    }
    if (resource == "programme-overwrite-posters") {
      return dataProvider.createPoster(resource, params);
    }
    if (resource == "programme-overwrite-poster-module") {
      return dataProvider.createPoster("programme-overwrite-posters", params);
    }
    if (resource == "profile-icons" || resource == "kids-profile-icons") {
      return dataProvider.createProfileIcon(resource, params);
    }
    if (resource == "editorial-types") {
      return dataProvider.createEditorial(resource, params);
    }
    if (resource == "slots") {
      return dataProvider.createSlot(resource, params);
    }
    if (resource == "events") {
      return dataProvider.createEvent(resource, params);
    }
    if (resource == "horserace-data") {
      return dataProvider.createHorseRaceData(resource, params);
    }
    if (resource == "password") {
      delete params.data.new_repeat_password;
      const url = `${apiUrl}/users/change-password`;

      const { json } = await httpClient(url, {
        method: "PUT",
        headers: await getAuthHeaders(),
        body: JSON.stringify(params.data),
      });

      return {
        data: convert_IdToId(json),
      };
    }
    if (resource == "mpm-pages") {
      params.data["rows"] = [];
      if (params.data.zoneimage_app_en_base64) {
        params.data.zoneimage_app_en_base64 = await blobToData(params.data.zoneimage_app_en_base64.rawFile);
      }
      if (params.data.zoneimage_app_tc_base64) {
        params.data.zoneimage_app_tc_base64 = await blobToData(params.data.zoneimage_app_tc_base64.rawFile);
      }
      if (params.data.zoneimage_stb_en_base64) {
        params.data.zoneimage_stb_en_base64 = await blobToData(params.data.zoneimage_stb_en_base64.rawFile);
      }
      if (params.data.zoneimage_stb_tc_base64) {
        params.data.zoneimage_stb_tc_base64 = await blobToData(params.data.zoneimage_stb_tc_base64.rawFile);
      }
      if (params.data.zoneimage_web_en_base64) {
        params.data.zoneimage_web_en_base64 = await blobToData(params.data.zoneimage_web_en_base64.rawFile);
      }
      if (params.data.zoneimage_web_tc_base64) {
        params.data.zoneimage_web_tc_base64 = await blobToData(params.data.zoneimage_web_tc_base64.rawFile);
      }
    }

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params.data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createSubcatFilterOverwrite: async (params) => {
    const data = {
      category_tag_id: parseInt(params.data.id),
      sub_category_tag_id: parseInt(params.data.sub_category_tag_id),
    };

    const url = `${apiUrl}/subcat-filter-overwrite`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createEditorial: async (resource, params) => {
    const url = `${apiUrl}/mpm-row-schedule-types`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params.data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createHotSearch: async (resource, params) => {
    const data = {
      search: params.data.search,
      enabled: params.data.enabled,
      profile_class: params.data.pc == "kids" ? ["kids"] : ["general"],
    };

    const url = `${apiUrl}/hot-searchs`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateHotSearchs: async (resource, params) => {
    const data = {
      search: params.data.search,
      enabled: params.data.enabled,
      profile_class: params.data.pc == "kids" ? ["kids"] : ["general"],
    };

    const url = `${apiUrl}/hot-searchs/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createEvent: async (resource, params) => {
    let render = {};
    const resDataPortrait = await blobToData(params.data.portrait_poster_base64.rawFile);
    const resDataLandscape = await blobToData(params.data.landscape_poster_base64.rawFile);

    render.portrait_poster_base64 = resDataPortrait;
    render.landscape_poster_base64 = resDataLandscape;
    render.title = params.data.title;
    render.type = params.data.key;

    let codes = [];
    let topic = [];
    for (const code of params.data.codes) {
      if (code.sports_event_code && typeof code.sports_event_code == "string") {
        topic = code.sports_event_code.split(",");
      } else {
        topic = code.sports_event_code;
      }

      codes.push({
        sports_topic_code: code.sports_topic_code,
        sports_event_code: topic,
      });
    }

    render.codes = codes;

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createKeyValue: async (resource, params) => {
    let values = [];
    if (params.data.values && typeof params.data.values == "string") {
      values = params.data.values.split(",");
    } else {
      values = params.data.values;
    }
    delete params.data.values;
    const render = params.data;
    render.values = values;
    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createHorseRaceData: async (resource, params) => {
    let render = params.data;
    if (params.data.image_base64) {
      const resDataimage = await blobToData(params.data.image_base64.rawFile);
      render.image_base64 = resDataimage;
    }
    let race_no = parseFloat(params.data.race_no);
    render.race_no = race_no;
    render.image_type = "Background";

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(render),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createChannel: async ({ data }) => {
    let resDataPortrait;
    let resDataLandscape;
    let resDisclaimer;
    let resCopyrightPoster;

    if (data.portrait_poster_base64) {
      resDataPortrait = await blobToData(data.portrait_poster_base64.rawFile);
    }
    if (data.landscape_poster_base64) {
      resDataLandscape = await blobToData(data.landscape_poster_base64.rawFile);
    }
    if (data.disclaimer_image_base64) {
      resDisclaimer = await blobToData(data.disclaimer_image_base64.rawFile);
    }
    if (data.copyright_poster_base64) {
      resCopyrightPoster = await blobToData(data.copyright_poster_base64.rawFile);
    }

    const profileClass = data.made_for_kid ? ["general", "kids"] : ["general"];
    const locations = {
      allowlist: {
        countries: data.region,
      },
    };

    const bodyObj = {
      start_time: HKDate(data.start_time),
      end_time: HKDate(data.end_time),
      channel_no: data.channel_no,
      network_code: data.network_code,
      name_en: data.name_en,
      name_tc: data.name_tc,
      timeshift: data.timeshift,
      catchup: data.catchup,
      orientation: data.orientation,
      overwrite_network_code: data.overwrite_network_code,
      show_num: data.show_num,
      mcdn_appname: data.mcdn_appname,
      bitrate_profile: data.bitrate_profile,
      coding_profile: data.coding_profile,
      drm_profile: data.drm_profile,
      aspect_ratio: data.aspect_ratio,
      audio_1: data.audio_1,
      audio_2: data.audio_2,
      audio_3: data.audio_3,
      remark: data.remark,
      enabled: data.enabled,
      locked: data.locked,
      is_default: data.is_default,
      is_dtt: data.is_dtt,
      is_interactive: data.is_interactive,
      is_4k: data.is_4k,
      is_rtc: data.is_rtc,
      show_with_subscription: data.show_with_subscription,
      call_ad: data.call_ad,
      show_in_listing: data.show_in_listing,
      has_flash_sync_u_wall: data.has_flash_sync_u_wall,
      is_whitelist: data.is_whitelist,
      has_im: data.has_im,
      tags: data.tags,
      channel_category_ids: data.channel_category_ids,
      platform: data.platform,
      locations: locations,
      landscape_poster_base64: resDataLandscape,
      portrait_poster_base64: resDataPortrait,
      disclaimer_image_base64: resDisclaimer,
      copyright_poster_base64: resCopyrightPoster,
      listen_copyright_schedules: data.listen_copyright_schedules,
      profile_class: profileClass,
    };

    const url = `${apiUrl}/channels`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(bodyObj),
    });

    if (data.restricted_schedule_updated && Array.isArray(data.restricted_schedule)) {
      const networkCode = data.overwrite_network_code ? data.overwrite_network_code : data.network_code;
      await dataProvider.createChannelCopyrightSchedule(networkCode, data.restricted_schedule);
    }

    return {
      data: convert_IdToId(json),
    };
  },

  createChannelCopyrightSchedule: async (networkCode, schedules) => {
    console.log("createChannelCopyrightSchedule", networkCode, schedules);

    if (!networkCode || !Array.isArray(schedules)) {
      return;
    }

    const searchParams = new URLSearchParams();
    searchParams.append("network_code", networkCode);

    const arr = schedules.map((schedule) => ({
      start_date: schedule.start_date,
      end_date: schedule.end_date,
      region: schedule.region,
      type: schedule.type,
      start_time: schedule.start_time,
      end_time: schedule.end_time,
    }));

    const url = `${apiUrl}/channel-copyright-schedule?${searchParams.toString()}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify({
        schedule: arr,
      }),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createNotification: async (resource, params) => {
    const accessToken = await getAccessToken();
    const decodedToken = decodeJwt(accessToken);
    delete params.data.programme;
    delete params.data.channel_id;
    delete params.data.episode_id;

    // push now
    var scheduled_push_start_date = HKDate(params.data.scheduled_push_start_date);
    if (params.data.push_now_toggle) {
      scheduled_push_start_date = moment().toISOString();
    } else {
      // push schedule date validation
      if (moment(scheduled_push_start_date) < moment()) throw new Error("Please input the correct scheduled push start date/ time");
    }
    delete params.data.push_now_toggle;

    var data = params.data;
    data.modified_by = decodedToken.sub;

    // photo
    if (params.data.image_base64) {
      if (params.data.image_base64 == "remove") {
        delete params.data.image_base64;
      } else {
        params.data.image_base64 = await blobToData(params.data.image_base64.rawFile);
      }
    }

    delete data.scheduled_push_start_date;
    data.scheduled_push_start_date = scheduled_push_start_date;

    const url = `${apiUrl}/${resource}`;
    let res = {};
    const pl = data.pla;
    delete data.pla;
    for (const platform of pl) {
      data.platform = platform;

      const { json } = await httpClient(url, {
        method: "POST",
        headers: await getAuthHeaders(),
        body: JSON.stringify(data),
      });
      res = json;
    }

    return {
      data: convert_IdToId(res),
    };
  },

  createProfileIcon: async (resource, params) => {
    const profileIcons = [];
    if (params.data.profile_icons) {
      for (const item of params.data.profile_icons) {
        profileIcons.push({
          icon_base64: await blobToData(item.icon_base64.rawFile),
          enabled: item.enabled,
        });
      }
    }

    const data = {
      series_tc: params.data.series_tc,
      series_en: params.data.series_en,
      series_icon: await blobToData(params.data.series_icon_base64.rawFile),
      enabled: params.data.enabled,
      show_in_frontend: params.data.show_in_frontend,
      profile_class: params.data.pc == "kids" ? ["general", "kids"] : ["general"],
      profile_icons: profileIcons,
    };

    const url = `${apiUrl}/profile-icons`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  delete: async (resource, params) => {
    if (resource == "epg-modification") {
      return dataProvider.deleteEpgSpecialItem(params);
    }

    if (resource == "epg-edit-listing") {
      return dataProvider.deleteEpgEditListing(params);
    }

    if (resource == "channel-categories") {
      return dataProvider.deleteChannelCategory(params);
    }

    if (resource == "kids-profile-icons") {
      resource = "profile-icons";
    }

    if (resource == "push-notifications") {
      return dataProvider.deletePushNotification(resource, params);
    }

    if (resource == "slots") {
      return dataProvider.deleteSlot(resource, params);
    }

    if (resource == "editorial-types") {
      resource = "mpm-row-schedule-types";
    }

    if (resource == "menu-tree") {
      return dataProvider.deleteMenuTree(resource, params);
    }

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    if (resource == "ads-video") {
      return {
        data: {
          id: params.id,
        },
      };
    }

    return {
      data: convert_IdToId(json),
    };
  },

  deleteEpgEditListing: async (params) => {
    const url = `${apiUrl}/epg-item-replacement/${params.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deleteEpgSpecialItem: async (params) => {
    const url = `${apiUrl}/epg-special-items/${params.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deleteSubcatFilterOverwrite: async (params) => {
    const url = `${apiUrl}/subcat-filter-overwrite/${params.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deleteAllSubcatFilterOverwrite: async (params) => {
    const url = `${apiUrl}/subcat-filter-overwrite/category?category_tag_id=${params.category_tag_id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deleteMenuTree: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    }).catch((err) => {
      // handle error when cannot delete
      if (err.status == 400) throw err.body.message.join(", ");
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deleteHotSearches: async (resource, params) => {
    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  deleteChannelCategory: async (params) => {
    const url = `${apiUrl}/channel-categories/${params.id}`;

    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  deletePushNotification: async (resource, params) => {
    const url = `${apiUrl}/push-notifications/${params.id}`;

    const data = {
      status: "cancelled",
    };
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  deleteSlot: async (resource, params) => {
    const url = `${apiUrl}/mpm-row-schedules/slot?type=${params.previousData.type}&slot_id=${params.previousData.id}`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  deleteMany: async (resource, params) => {
    if (resource == "vipo-blacklist") {
      return dataProvider.deleteManyVipoBlacklist(params.ids);
    }

    const headers = await getAuthHeaders();
    if (resource == "editorial-types") {
      resource = "mpm-row-schedule-types";
    }
    const items = await Promise.all(
      params.ids.map((id) => {
        const url = `${apiUrl}/${resource}/${id}`;
        return httpClient(url, {
          method: "DELETE",
          headers: headers,
        }).then(({ json }) => {
          return convert_IdToId(json);
        });
      }),
    );
    return { data: items };
  },

  deleteManyVipoBlacklist: async (ids) => {
    const data = {
      id: ids,
    };
    const url = `${apiUrl}/vipo-blacklist`;
    const { json } = await httpClient(url, {
      method: "DELETE",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  // Menu Tree
  postMenuTree: async (params) => {
    // add back description if it is empty string
    if (!params.description) params.description = "";

    const url = `${apiUrl}/menu-tree`;

    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params),
    });

    return {
      data: json,
    };
  },

  putMenuTree: async (id, params) => {
    const url = `${apiUrl}/menu-tree/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params),
    });

    return {
      data: json,
    };
  },

  // Get Tags
  getTags: async (tagIds) => {
    var query = {
      page: 1,
      limit: 999999,
      where: {
        $or: tagIds.map((tagId) => ({ tag_id: tagId })),
      },
    };

    const url = `${apiUrl}/tags?query=` + JSON.stringify(query);

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: json.data,
    };
  },

  // import requests
  getManyProgrammesForImportRequests: async (resource, params) => {
    const query = { where: { programme_id: { $in: params.ids } } };

    const url = `${apiUrl}/programmes?query=${JSON.stringify(query)}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    const data2 = json.data.map((item) => {
      return {
        id: item.programme_id,
        name_tc: item.name_tc,
        name_en: item.name_en,
      };
    });

    return {
      data: data2,
      total: json.total,
    };
  },

  createImportRequests: async (resource, params) => {
    // change id from string to number
    params.data.resource_id = parseInt(params.data.resource_id);

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params.data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateMpmRowsOrderByPlatformByPageId: async (pageId, platformOrders) => {
    console.log("updateMpmRowsOrderByPlatformByPageId", pageId, platformOrders);

    const platforms = ["stb", "android_tv", "samsung_tv", "web", "ios", "android", "lg_tv"];

    const arr = [];
    for (const platform of platforms) {
      const rows = Object.keys(platformOrders)
        .filter((id) => {
          //Filter out the rows that have no order value for this platform
          const value = platformOrders[id][platform];
          return value !== undefined && value !== null && value !== "";
        })
        .sort((a, b) => {
          //sort asc
          return platformOrders[a][platform] - platformOrders[b][platform];
        });

      arr.push({
        platform: platform,
        rows: rows,
      });
    }

    const url = `${apiUrl}/mpm-rows-order-by-platform`;

    const data = {
      page_id: pageId,
      order_by_platform: arr,
    };
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateMpmRowsOrderByPlatformByPlatformId: async (platformId, rows) => {
    const url = `${apiUrl}/mpm-rows-order-by-platform/platform/${platformId}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify({
        rows: rows.map((row) => row.id),
      }),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateMpmPages: async (resource, params) => {
    // select the page out and check the page_row diff
    const oldPage = await dataProvider.getOne("mpm-pages", { id: params.id });
    const oldRows = oldPage.data.rows;
    const newRows = params.data.rows;
    const removeRows = oldRows.filter((oldRow) => !newRows.includes(oldRow));

    // delete the removeRows
    const removeRowsPromise = removeRows.map(async (removeRow) => {
      const url = `${apiUrl}/mpm-rows/${removeRow}`;

      return httpClient(url, {
        method: "DELETE",
        headers: await getAuthHeaders(),
      });
    });

    // wait the delete rows complete
    await Promise.all(removeRowsPromise);

    // process on upload image
    for (const name of ["zoneimage_app_tc", "zoneimage_app_en", "zoneimage_stb_tc", "zoneimage_stb_en", "zoneimage_web_tc", "zoneimage_web_en"]) {
      delete params.data[name];

      if (params.data[name + "_base64"]) {
        if (params.data[name + "_base64"] == "remove") {
          params.data[name + "_base64"] = null;
        } else {
          params.data[name + "_base64"] = await blobToData(params.data[name + "_base64"].rawFile);
        }
      }
    }

    if (params.data.pc == "kids") {
      params.data["profile_class"] = ["general", "kids"];
    } else {
      if (params.data.made_for_kid) {
        params.data["profile_class"] = ["general", "kids"];
      } else {
        params.data["profile_class"] = ["general"];
      }
    }

    //If homepage, check pc
    //If not home page, check made_for_kid
    if (params.data.is_homepage) {
      params.data["profile_class"] = params.data.pc == "kids" ? ["general", "kids"] : ["general"];
    } else {
      if (params.data.made_for_kid) {
        params.data["profile_class"] = ["general", "kids"];
      } else {
        params.data["profile_class"] = ["general"];
      }
    }

    //It's only for is_olympic now
    if (params.data.template && params.data.template.length > 0) {
      params.data["is_olympic"] = true;
    } else {
      params.data["is_olympic"] = false;
    }

    //Delete basic useless params
    delete params.data.id;
    delete params.data.created_at;
    delete params.data.modified_at;
    delete params.data.__v;
    delete params.data.pc;
    delete params.data.template;

    //Delete old params
    delete params.data.banner_image;
    delete params.data.name;

    if (!enableMpmPlatformOrdering) {
      delete params.data.platform_orders;
    }

    var data = params.data;

    const url = `${apiUrl}/${resource}/${params.id}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    if (enableMpmPlatformOrdering) {
      await dataProvider.updateMpmRowsOrderByPlatformByPageId(params.id, params.data.platform_orders);
    }

    return {
      data: convert_IdToId(json),
    };
  },

  createMpmPages: async (resource, params) => {
    params.data["profile_class"] = ["general"];

    for (const name of ["zoneimage_app_tc", "zoneimage_app_en", "zoneimage_stb_tc", "zoneimage_stb_en", "zoneimage_web_tc", "zoneimage_web_en"]) {
      delete params.data[name];

      if (params.data[name + "_base64"]) {
        if (params.data[name + "_base64"] == "remove") {
          params.data[name + "_base64"] = null;
        } else {
          params.data[name + "_base64"] = await blobToData(params.data[name + "_base64"].rawFile);
        }
      }
    }

    //It's only for is_olympic now
    if (params.data.template && params.data.template.length > 0) {
      params.data["is_olympic"] = true;
    } else {
      params.data["is_olympic"] = false;
    }

    params.data.rows = [];

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(params.data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  postImportRequestForSubcatFilters: async () => {
    const data = {
      from: "sfm",
      resource: "subcat_filters",
      resource_id: -1,
    };

    const url = `${apiUrl}/import-requests`;

    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getImportRequestForSubcatFilters: async () => {
    const query = {
      where: { resource: "subcat_filters" },
      sort: "-modified_at",
    };

    const url = `${apiUrl}/import-requests?query=${JSON.stringify(query)}`;
    const result = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: result.json.data[0],
    };
  },

  updatePagePath: async (params) => {
    var data = {
      path: params.data.path,
    };

    const url = `${apiUrl}/mpm-pages/${params.id}/path-ads`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updatePageRowPath: async (params) => {
    var data = {
      path: params.path,
    };

    const url = `${apiUrl}/mpm-rows/${params.page_id}/path-ads`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createMany: async (resource, params) => {
    if (resource == "episode-preview-schedules") {
      return dataProvider.createManyEpisodePreviewSchedules(params);
    }
  },

  createManyEpisodePreviewSchedules: async (params) => {
    const rows = [];

    const platformColumn = "0";
    const programmeIdColumn = "1";
    const episodeNoColumn = "2";
    const startTimeColumn = "3";
    const endTimeColumn = "4";

    params.data.map((item) => {
      try {
        const numberRegex = /^[0-9]*$/gm;
        if (typeof item[programmeIdColumn] == "string" && !item[programmeIdColumn].match(numberRegex)) throw "programme_id is invalid";

        const row = {
          platform: item[platformColumn],
          programme_id: parseInt(item[programmeIdColumn]),
          episode_no: item[episodeNoColumn] == "all" ? "all" : item[episodeNoColumn].split(","), // episode_no can be 'all' or '1,2,3'
          start_time: moment(item[startTimeColumn], "YYYYMMDDHHmm"),
          end_time: moment(item[endTimeColumn], "YYYYMMDDHHmm"),
        };

        if ([NaN, null].includes(row.programme_id)) throw "programme_id is invalid";
        if (row.episode_no.length == 0) throw "episode_no is empty";
        if ([NaN, null].includes(row.episode_no[0])) throw "episode_no is null";

        // episode_no can be 'all' or '1,2,3'
        if (row.episode_no != "all") {
          row.episode_no = row.episode_no.map((ep) => {
            if (ep < 1) throw "episode_no[" + ep + "] must not less than 1"; // ep should not less than 1
            if (typeof ep == "string" && !ep.match(numberRegex)) throw "episode_no is not number"; // ep should be numeric

            return ep;
          });
          row.episode_no = row.episode_no
            .filter((item) => {
              const b = !item ? false : true;

              return b;
            })
            .map((item) => {
              return parseInt(item);
            });
        }

        if (row.start_time._isValid == false) throw "start_time is invalid";
        if (row.end_time._isValid == false) throw "end_time is invalid";

        row.platform = row.platform ? row.platform.split(",") : ["web"];
        // if (!row.platform) throw "platform is empty";
        // if (!Array.isArray(row.platform)) throw "platform must be array";

        rows.push(row);
      } catch (e) {
        console.log(e);
      }
    });

    const data = {
      schedules: rows,
    };

    const url = `${apiUrl}/episode-preview-schedules`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: json,
    };
  },

  createIMCannedMessage: async (resource, params) => {
    const data = {
      text: params.data.text,
    };

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createIMCannedMessageList: async (params) => {
    var cannedMessages = [];
    if (params.canned_messages) {
      for (const [i, value] of params.canned_messages.entries()) {
        var obj = {
          text: value.text,
          order: i,
          enabled: value.enabled,
        };

        if (!value.id) {
          //Create im-canned-message if not exist
          var result = await dataProvider.createIMCannedMessage("im-canned-messages", { data: { text: value.text } });
          obj["_id"] = result.data.id;
        } else {
          obj["_id"] = value.id;
        }

        cannedMessages.push(obj);
      }
    }

    const data = {
      name: params.name,
      question: params.question,
      tnc: params.tnc ?? "",
      start_time: params.start_time,
      end_time: params.end_time,
      canned_messages: cannedMessages,
      list_type: params.voting_enabled ? "vote" : "default",
    };

    const url = `${apiUrl}/im-canned-message-list`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateIMCannedMessageList: async (id, params) => {
    var cannedMessages = [];
    if (params.canned_messages) {
      for (const [i, value] of params.canned_messages.entries()) {
        var obj = {
          text: value.text,
          order: i,
          enabled: value.enabled,
        };

        //DO NOT PROVIDE _id for canned_message item in field "canned_messages" IF NOT PRESENT IN collection im-canned-message
        if (!value.id) {
          //Create im-canned-message if not exist
          var result = await dataProvider.createIMCannedMessage("im-canned-messages", { data: { text: value.text } });
          obj["_id"] = result.data.id;
        } else {
          obj["_id"] = value.id;
        }

        cannedMessages.push(obj);
      }
    }

    const data = {
      name: params.name,
      question: params.question,
      tnc: params.tnc ?? "",
      start_time: params.start_time,
      end_time: params.end_time,
      canned_messages: cannedMessages,
      list_type: params.voting_enabled ? "vote" : "default",
    };

    const url = `${apiUrl}/im-canned-message-list/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createIMProducts: async (params) => {
    var products = [];

    for (const value of params) {
      //product_image is URL if Clone chatroom
      var product_image;
      if (value.product_picture_file) {
        product_image = await blobToData(value.product_picture_file.rawFile);
      } else {
        product_image = value.product_image;
      }

      products.push({
        title: value.title,
        description: value.description,
        live_promote_text: value.live_promote_text,
        purchase_button_text: value.purchase_button_text,
        product_url: value.product_url,
        is_in_app_url: value.open_url == "in_app",
        // product_image: await blobToData(value.product_picture_file.rawFile),
        product_image: product_image,
        is_onshelf: value.is_onshelf,
        is_live_promote: value.is_live_promote,
      });
    }

    const data = {
      products: products,
    };

    const url = `${apiUrl}/im-room-products`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };

    // return {
    //   data: convert_IdToId([
    //     {
    //       _id: "aaaaa",
    //     },
    //     {
    //       _id: "bbbbb",
    //     },
    //     {
    //       _id: "ccccc",
    //     },
    //   ]),
    // };
  },

  createIMIconList: async (params, start_time, end_time) => {
    var icons = [];
    for (const [i, value] of params.entries()) {
      icons.push({
        _id: value.id,
        type: value.type,
        pack_id: value.pack_id, //only paid icon
        image_url: value.image_url, //only free icon
        purchase_image_info: value.purchase_image_info, //only paid icon
        order: i,
        enabled: value.enabled,
      });
    }

    const data = {
      icons: icons,
      start_time: start_time,
      end_time: end_time,
      // start_time: "2023-03-09T10:22:04.574Z", //NOTE: UI doesn't have this value
      // end_time: "2030-03-09T10:22:04.574Z", //NOTE: UI doesn't have this value
    };

    const url = `${apiUrl}/im-icon-list`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  updateIMIconList: async (id, params, start_time, end_time) => {
    var icons = [];
    for (const [i, value] of params.entries()) {
      icons.push({
        _id: value.id,
        type: value.type,
        pack_id: value.pack_id, //only paid icon
        image_url: value.image_url, //only free icon
        purchase_image_info: value.purchase_image_info, //only paid icon
        order: i,
        enabled: value.enabled,
      });
    }

    const data = {
      icons: icons,
      start_time: start_time,
      end_time: end_time,
      // start_time: "2023-03-09T10:22:04.574Z", //NOTE: UI doesn't have this value
      // end_time: "2030-03-09T10:22:04.574Z", //NOTE: UI doesn't have this value
    };

    const url = `${apiUrl}/im-icon-list/${id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  createIMChatroom: async (resource, params) => {
    //1. Create im-canned-message-list
    var cannedMessageList = [];
    if (params.data.canned_message_list) {
      for (const obj of params.data.canned_message_list) {
        const imCannedMessageListItem = await dataProvider.createIMCannedMessageList(obj);
        cannedMessageList.push(imCannedMessageListItem.data);
      }
    }

    //2. Create im-icon-list
    var iconList = [];
    if (params.data.icons && params.data.icons.length > 0) {
      const imIconList = await dataProvider.createIMIconList(params.data.icons, params.data.start_time, params.data.end_time);
      iconList = [imIconList.data];
    }

    //3. Create im-product-list
    var productList = [];
    if (params.data.products && params.data.products.length > 0) {
      const imProducts = await dataProvider.createIMProducts(params.data.products);
      productList = imProducts.data.products;
    }

    //3.
    const canned_message_list_ids = cannedMessageList.map((e) => e.id);
    const icon_list_ids = iconList.map((e) => e.id);
    const room_products_ids = productList.map((e) => e.id);

    let promote_info = null;
    if (params.data.layout == "l-shape") {
      promote_info = {
        promote_banner: await blobToData(params.data.promote_banner_base64.rawFile),
        promote_message: params.data.promote_message ?? "",
        promote_message_color_code: params.data.promote_message_color_code ?? "",
        promote_message_background_color_code: params.data.promote_message_background_color_code ?? "",
        promote_url: params.data.promote_url ?? "",
      };
    }

    const data = {
      name: params.data.name,
      channels_popup_mode: params.data.channels_popup_mode,
      // channel_no: params.data.channel_no,
      // channel_no: params.data.channel_no.split(",").map((cn) => parseInt(cn)),
      channel_no: params.data.channels_popup_mode.map((cpm) => parseInt(cpm.channel_no)),
      programme_id: params.data.programme_id ?? null,
      // programme_en: params.data.title_en,
      // programme_tc: params.data.title_tc,
      episode_no: params.data.episode_no ? parseInt(params.data.episode_no) : undefined,
      // episode_no: parseInt(params.data.episode_no),
      // video_id: params.data.video_id,
      //platform: ??,
      mode: params.data.mode || "default",
      platform: params.data.platform,
      qr_code_entry: params.data.qr_code_entry,
      start_time: params.data.start_time,
      end_time: params.data.end_time,
      enabled: true, //NOTE: API required, but UI doesn't have this input
      // canned_message_list: cannedMessageList,
      artist_message_color_code: params.data.artist_message_color_code,
      artist_message_background_color_code: params.data.artist_message_background_color_code,
      artist_username_color_code: params.data.artist_username_color_code,
      chat_message_color_code: params.data.chat_message_color_code,
      chat_background_color_code: params.data.chat_background_color_code,
      username_color_code: params.data.username_color_code,
      icon_list_ids: icon_list_ids,
      canned_message_list_ids: canned_message_list_ids,
      room_products_ids: room_products_ids,
      stats_config: {
        initial_popularity: params.data.initial_popularity ?? 0,
        initial_likes: params.data.initial_likes ?? 0,
        pop_min_growth_factor: params.data.pop_min_growth_factor ?? 1,
        pop_max_growth_factor: params.data.pop_max_growth_factor ?? 1,
        pop_min_reduction_coefficient: params.data.pop_min_reduction_coefficient ?? 1,
        pop_max_reduction_coefficient: params.data.pop_max_reduction_coefficient ?? 1,
        like_min_growth_factor: params.data.like_min_growth_factor ?? 1,
        like_max_growth_factor: params.data.like_max_growth_factor ?? 1,
        like_min_reduction_coefficient: params.data.like_min_reduction_coefficient ?? 1,
        like_max_reduction_coefficient: params.data.like_max_reduction_coefficient ?? 1,
      },
      promote_info: promote_info,
      layout: params.data.layout,

      // icon_list: iconList,
    };

    const url = `${apiUrl}/${resource}`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateIMChatroom: async (resource, params) => {
    const roomStatus = getIMStatus(params.data.start_time, params.data.end_time);

    //1. Create im-canned-message-list
    var cannedMessageList = [];
    var iconList = [];
    var productList = [];

    //Only update or create if preview / live
    if (roomStatus != "end") {
      if (params.data.canned_message_list) {
        for (const obj of params.data.canned_message_list) {
          //Create new /im-canned-message-list if id doesn't exist
          if (!obj.id) {
            const imCannedMessageListItem = await dataProvider.createIMCannedMessageList(obj);
            cannedMessageList.push(imCannedMessageListItem.data);
          } else {
            const status = getIMStatus(obj.start_time, obj.end_time);

            //If the canned-messages is end, cannot update
            if (status != "end") {
              const imCannedMessageListItem = await dataProvider.updateIMCannedMessageList(obj.id, obj);
              cannedMessageList.push(imCannedMessageListItem.data);
            } else {
              cannedMessageList.push(obj);
            }
          }
        }
      }

      //2. Create im-icon-list
      if (params.data.icons) {
        //im-icon-list already exist, udpate it instead of create new one
        if (params.data.icon_list_id) {
          const imIconList = await dataProvider.updateIMIconList(params.data.icon_list_id, params.data.icons, params.data.start_time, params.data.end_time);
          iconList = [imIconList.data];
        } else {
          //Create new one if im-icon-list not exist
          if (params.data.icons.length > 0) {
            const imIconList = await dataProvider.createIMIconList(params.data.icons, params.data.start_time, params.data.end_time);
            iconList = [imIconList.data];
          }
        }
      }

      //3. im-product-list
      if (params.data.products) {
        for (const product of params.data.products) {
          if (product.isNew) {
            const result = await dataProvider.createIMProducts([product]);
            productList.push(result.data.products[0]);
          } else {
            const result = await dataProvider.updateIMProduct(product);
            productList.push(result.data.products[0]);
          }
        }
      }
    } else {
      if (params.data.canned_message_list) {
        for (const obj of params.data.canned_message_list) {
          cannedMessageList.push({ id: obj.id });
        }
      }
      if (params.data.icons) {
        if (params.data.icon_list_id) {
          iconList.push({ id: params.data.icon_list_id });
        }
      }
      if (params.data.products) {
        for (const obj of params.data.products) {
          productList.push({ id: obj.id });
        }
      }
    }

    //3.
    const canned_message_list_ids = cannedMessageList.map((e) => e.id);
    const icon_list_ids = iconList.map((e) => e.id);
    const room_products_ids = productList.map((e) => e.id);

    let promote_info = null;
    if (params.data.layout == "l-shape") {
      promote_info = {
        // promote_banner:  await blobToData(params.data.promote_banner_base64.rawFile),
        promote_message: params.data.promote_message ?? "",
        promote_message_color_code: params.data.promote_message_color_code ?? "",
        promote_message_background_color_code: params.data.promote_message_background_color_code ?? "",
        promote_url: params.data.promote_url ?? "",
      };

      if (params.data.promote_banner_base64) {
        promote_info["promote_banner"] = await blobToData(params.data.promote_banner_base64.rawFile);
      } else {
        promote_info["promote_banner"] = params.data.promote_banner;
      }
    }

    const data = {
      name: params.data.name,
      channels_popup_mode: params.data.channels_popup_mode,
      // channel_no: params.data.channel_no,
      // channel_no: params.data.channel_no.split(",").map((cn) => parseInt(cn)),
      channel_no: params.data.channels_popup_mode.map((cpm) => parseInt(cpm.channel_no)),
      programme_id: params.data.programme_id ?? null,
      // programme_en: params.data.title_en,
      // programme_tc: params.data.title_tc,
      episode_no: params.data.episode_no ? parseInt(params.data.episode_no) : undefined,
      // episode_no: parseInt(params.data.episode_no),
      // video_id: params.data.video_id,
      //platform: ??,
      mode: params.data.mode || "default",
      platform: params.data.platform,
      qr_code_entry: params.data.qr_code_entry,
      start_time: params.data.start_time,
      end_time: params.data.end_time,
      enabled: true, //NOTE: API required, but UI doesn't have this input
      // canned_message_list: cannedMessageList,
      artist_message_color_code: params.data.artist_message_color_code,
      artist_message_background_color_code: params.data.artist_message_background_color_code,
      artist_username_color_code: params.data.artist_username_color_code,
      chat_message_color_code: params.data.chat_message_color_code,
      chat_background_color_code: params.data.chat_background_color_code,
      username_color_code: params.data.username_color_code,

      icon_list_ids: icon_list_ids,
      canned_message_list_ids: canned_message_list_ids,
      room_products_ids: room_products_ids,
      stats_config: {
        initial_popularity: params.data.initial_popularity ?? 0,
        initial_likes: params.data.initial_likes ?? 0,
        pop_min_growth_factor: params.data.pop_min_growth_factor ?? 1,
        pop_max_growth_factor: params.data.pop_max_growth_factor ?? 1,
        pop_min_reduction_coefficient: params.data.pop_min_reduction_coefficient ?? 1,
        pop_max_reduction_coefficient: params.data.pop_max_reduction_coefficient ?? 1,
        like_min_growth_factor: params.data.like_min_growth_factor ?? 1,
        like_max_growth_factor: params.data.like_max_growth_factor ?? 1,
        like_min_reduction_coefficient: params.data.like_min_reduction_coefficient ?? 1,
        like_max_reduction_coefficient: params.data.like_max_reduction_coefficient ?? 1,
      },
      promote_info: promote_info,
      layout: params.data.layout,
      send_dtt_config: {
        artist_only: params.data.send_dtt_config.artist_only ?? false,
        allow_user_canned_message: params.data.send_dtt_config.allow_user_canned_message ?? true,
        allow_user_free_message: params.data.send_dtt_config.allow_user_free_message ?? true,
        public_message_char_limit: params.data.send_dtt_config.public_message_char_limit ?? 50,
        response_message_limit: params.data.send_dtt_config.response_message_limit ?? 20,
        artist_message_char_limit: params.data.send_dtt_config.artist_message_char_limit ?? 70,
        special_message_char_limit: params.data.send_dtt_config.special_message_char_limit ?? 70,
      },

      // icon_list: iconList,
    };

    const url = `${apiUrl}/${resource}/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(convertIdTo_Id(data)),
    });

    return {
      data: convert_IdToId(json),
    };
  },
  getProfilesPreferences: async (resource, params) => {
    const queryObj = {
      // sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: 1,
      limit: 99999,
      where: {
        profile_class: params.filter.profile_class,
      },
    };

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/profiles-preferences?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    const d = json.data[0];

    //copy tag_id to id
    for (const tag of d.tags) {
      tag["id"] = tag.tag_id;
      tag["pp_id"] = d._id; //NOTE: DIRTY, but to give the _id to each element in order to update later
    }

    return d;
  },

  getListChannelOrdering: async () => {
    const queryObj = {
      sort: "order", // (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: 1,
      limit: 999999,
      // page: page,
      // limit: perPage,
    };

    const url = `${apiUrl}/channels?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  addVipoBlacklist: async (programmeId) => {
    const programmeData = await dataProvider.getProgrammeByProgrammeId(programmeId);

    if (programmeData && programmeData.data) {
      const programme = programmeData.data;

      const data = {
        programme_id: programmeId,
        name_tc: programme.name_tc,
        name_en: programme.name_en,
      };

      const url = `${apiUrl}/vipo-blacklist`;
      const { json } = await httpClient(url, {
        method: "POST",
        headers: await getAuthHeaders(),
        body: JSON.stringify(data),
      });

      return {
        data: convert_IdToId(json),
      };
    }

    return {};
  },

  getManyMpmRows: async (resource, params) => {
    var query = "";

    query = JSON.stringify({ limit: 99999, where: { _id: { $in: params.ids } } });

    const url = `${apiUrl}/${resource}?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      //Because ref is keyword, we need to rename it
      delete Object.assign(item, { ref_x: item["ref"] })["ref"];

      item.region = convertJsonToRegion(item);

      if (item["type"] == "editorial_pick") {
        if (item["ref_x"].startsWith("events")) {
          item["type"] = "event";
        }
      }
    }

    var items = json.data;

    return {
      data: convert_IdToId(items),
      total: json.total,
    };
  },
  getListMpmRows: async (resource, params) => {
    const { page, perPage } = params.pagination;
    const { field, order } = params.sort;

    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    const filterKeys = Object.keys(params.filter);
    if (filterKeys.length !== 0) {
      const filter = [];
      filterKeys.forEach((key) => {
        let expr;
        switch (typeof params.filter[key]) {
          case "string": {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = {
                $expr: {
                  $regexMatch: {
                    input: { $toString: `$${key}` },
                    regex: ".*" + _.escapeRegExp(params.filter[key]) + ".*",
                    options: "i",
                  },
                },
              };
            }

            break;
          }
          default: {
            if (key == "tags") {
              expr = { tags: params.filter[key] };
            } else {
              expr = { key: params.filter[key] };
            }
          }
        }
        filter.push(expr);
      });
      queryObj.where = { $and: filter };
    }

    let json;
    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/${resource}?query=${query}`;

    const response = await httpClient(url, {
      headers: await getAuthHeaders(),
    });
    json = response.json;

    let res = [];
    for (const item of json.data) {
      res.push(item);

      //Because ref is keyword, we need to rename it
      delete Object.assign(item, { ref_x: item["ref"] })["ref"];

      item.region = convertJsonToRegion(item);
    }

    return {
      data: convert_IdToId(res),
      total: json.total,
    };
  },
  getListMenuTree: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    // var where = { enabled: params.filter.enabled };
    queryObj.where = {};
    // if (params.filter.enabled) {
    //   queryObj.where.enabled = params.filter.enabled;
    // }

    // if (params.filter.requested_to_vipo) {
    //   queryObj.where.requested_to_vipo = params.filter.requested_to_vipo;
    // }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/menu-tree?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    for (const d of json.data) {
      for (const mt of d.menu_tree) {
        mt.region = convertJsonToRegion(mt);

        if (mt.categories) {
          for (const c of mt.categories) {
            c.region = convertJsonToRegion(c);
          }
        }
      }
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListVipoBlacklist: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    // var where = { enabled: params.filter.enabled };
    queryObj.where = {};
    if (params.filter.enabled) {
      queryObj.where.enabled = params.filter.enabled;
    }

    if (params.filter.requested_to_vipo) {
      queryObj.where.requested_to_vipo = params.filter.requested_to_vipo;
    }

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/vipo-blacklist?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
  getListProfileIcons: async (resource, params) => {
    var where = { profile_class: params.filter.profile_class };
    if (params.filter.series_tc) {
      where["series_tc"] = { $regex: params.filter.series_tc, $options: "i" };
    }
    if (params.filter.series_en) {
      where["series_en"] = { $regex: params.filter.series_en, $options: "i" };
    }
    if (params.filter.enabled) {
      where["enabled"] = params.filter.enabled;
    }
    if (params.filter.show_in_frontend) {
      where["show_in_frontend"] = params.filter.show_in_frontend;
    }

    const queryObj = {
      page: 1,
      limit: 99999,
      sort: "order",
      where: where,
    };

    const query = JSON.stringify(queryObj);
    const url = `${apiUrl}/profile-icons?query=${query}`;

    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListProfilesPreferences: async (resource, params) => {
    if (params.filter.allItems.length > 0) {
      return {
        data: params.filter.allItems,
        total: params.filter.allItems.length,
      };
      // return { data: [{ id: "1" }], total: 1 };
    }

    const d = await dataProvider.getProfilesPreferences(resource, params);

    var tags = d.tags;
    // if (params.filter.tag_id) {
    //   tags = tags.filter((t) => t.tag_id.toString().includes(params.filter.tag_id.toString()));
    // }
    // if (params.filter.name_tc) {
    //   tags = tags.filter((t) => t.name_tc.includes(params.filter.name_tc));
    // }
    // if (params.filter.name_en) {
    //   tags = tags.filter((t) => t.name_en.includes(params.filter.name_en));
    // }

    return {
      data: tags,
      total: tags.length,
    };
    // return {
    //   data: d.tags,
    //   total: d.tags.length,
    // };
  },

  getManyTagsAutocompleteByTagId: async (params) => {
    var where = { tag_id: { $in: params.ids } };
    var queryObj = { page: 1, limit: 99999 };
    queryObj.where = where;

    const url = `${apiUrl}/tags?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    // Reset id to tag_id
    for (const item of json.data) {
      item["_id"] = item.tag_id;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getManyTagsAutocomplete: async (resource, params) => {
    var where = { _id: { $in: params.ids } };
    var queryObj = { page: 1, limit: 99999 };
    queryObj.where = where;

    const url = `${apiUrl}/tags?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListTagsAutocompleteByTagId: async (params) => {
    if (!("q" in params.filter)) {
      return { data: [], total: 0 };
    }

    var where = {};
    if (params.filter.q) {
      const qAsInt = parseInt(params.filter.q, 10);
      const isInteger = !isNaN(qAsInt);
      const orClause = {
        $or: [
          //
          { name_tc: { $regex: params.filter.q, $options: "i" } },
          { name_en: { $regex: params.filter.q, $options: "i" } },
          ...(isInteger ? [{ tag_id: qAsInt }] : []),
        ],
      };

      const andClauses = [orClause];
      if (params.filter && params.filter.tag_type) {
        andClauses.push({ type: params.filter.tag_type });
      }

      where = { $and: andClauses };
    }

    var queryObj = { page: 1, limit: 99999, sort: "-tag_id" };
    queryObj.where = where;

    const url = `${apiUrl}/tags?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    // Reset id to tag_id
    for (const item of json.data) {
      item["_id"] = item.tag_id;
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListTagsAutocomplete: async (resource, params) => {
    if (!("q" in params.filter)) {
      return { data: [], total: 0 };
    }

    var where = {};
    if (params.filter.q) {
      const qAsInt = parseInt(params.filter.q, 10);
      const isInteger = !isNaN(qAsInt);

      const orClause = {
        $or: [
          //
          { name_tc: { $regex: params.filter.q, $options: "i" } },
          { name_en: { $regex: params.filter.q, $options: "i" } },
          ...(isInteger ? [{ tag_id: qAsInt }] : []),
        ],
      };

      const andClauses = [orClause];
      if (params.filter && params.filter.tag_type) {
        andClauses.push({ type: params.filter.tag_type });
      }

      where = { $and: andClauses };
    }

    var queryObj = { page: 1, limit: 99999, sort: "-tag_id" };
    queryObj.where = where;

    const url = `${apiUrl}/tags?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getListIMCannedMessages: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var query = {};
    if (params.filter.text) {
      query["text"] = {
        $regex: params.filter.text,
        $options: "i",
      };
      // query["text"] = ".*" + params.filter.text + ".*";
    }

    queryObj.where = query;

    const url = `${apiUrl}/im-canned-messages?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  getManyIMCannedMessages: async (resource, params) => {
    // var query = {};
    // if (params.filter.text) {
    //   query["text"] = {
    //     $regex: params.filter.text,
    //     $options: "i",
    //   };
    //   // query["text"] = ".*" + params.filter.text + ".*";
    // }

    // queryObj.where = query;

    const url = `${apiUrl}/im-canned-messages/${params.ids[0]}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    if (json.data) {
      return {
        data: convert_IdToId([json.data]),
        total: 1,
      };
    }
    return {
      data: [],
      total: 0,
    };
  },

  updateIMProduct: async (params) => {
    const product = {
      _id: params.id,
      title: params.title,
      description: params.description,
      live_promote_text: params.live_promote_text,
      purchase_button_text: params.purchase_button_text,
      product_url: params.product_url,
      is_in_app_url: params.open_url == "in_app",
      is_onshelf: params.is_onshelf,
      is_live_promote: params.is_live_promote,
    };

    if (params.product_picture_file) {
      product["product_image"] = await blobToData(params.product_picture_file.rawFile);
    } else {
      product["product_image"] = params.product_image;
    }

    const data = {
      products: [product],
    };

    // const url = `${apiUrl}/im-room-products/${params.id}`;
    const url = `${apiUrl}/im-room-products`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateIMCannedMessages: async (resource, params) => {
    const data = { text: params.data.text };

    const url = `${apiUrl}/im-canned-messages/${params.id}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateChannelCategoriesOrder: async (platform, ids) => {
    const data = {
      platform: platform,
      order: ids,
    };

    const url = `${apiUrl}/channel-categories-order`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateProfilesPreference: async (items, profileClass, profilesPreferenceId) => {
    const data = { profile_class: [profileClass], tags: items };

    const url = `${apiUrl}/profiles-preferences/${profilesPreferenceId}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createProfilesPreference: async (resource, params) => {
    const tagsResponse = await dataProvider.getOne("tags", { id: params.data.tag_id });
    const tag = tagsResponse.data;

    const profilesPreferencesData = await dataProvider.getProfilesPreferences("profiles-preferences", {
      filter: {
        profile_class: params.data.pc,
      },
    });

    //Check if tag exist already
    for (const t of profilesPreferencesData.tags) {
      if (t.tag_id == tag.tag_id) {
        throw Error("Tag has been added already");
      }
    }

    profilesPreferencesData.tags.push(tag);

    const data = { profile_class: profilesPreferencesData.profile_class, tags: profilesPreferencesData.tags };

    const url = `${apiUrl}/profiles-preferences/${profilesPreferencesData._id}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  createIMIcon: async (resource, params) => {
    var responseData;
    for (const icon of params.data.icon_base64) {
      const data = {
        image_base64: await blobToData(icon.rawFile),
      };

      const url = `${apiUrl}/${resource}`;
      const { json } = await httpClient(url, {
        method: "POST",
        headers: await getAuthHeaders(),
        body: JSON.stringify(data),
      });

      responseData = json;
    }

    return {
      data: convert_IdToId(responseData),
    };
  },

  updateIMIcon: async (resource, params) => {
    const data = {
      image_base64: await blobToData(params.data.icon_base64.rawFile),
    };

    const url = `${apiUrl}/im-icons/${params.id}`;

    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getAllIMIcons: async () => {
    const queryObj = {
      page: 1,
      limit: 99999,
    };
    const query = JSON.stringify(queryObj);

    const url = `${apiUrl}/im-icons?query=${query}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),

      total: json.total,
    };
  },

  getListScoopPlusShortsChannel: async () => {
    const url = `${apiUrl}/mpm-rows/scoopplus/shorts/channel`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    //Sort json.data by channel_id ASC
    json.data.sort((a, b) => a.channel_id - b.channel_id);

    const data = [];
    for (const item of json.data) {
      data.push({ id: item.channel_id, name: item.name });
    }

    return {
      data: data,
      total: data.length,
    };
  },

  getListTrafficLog: async (resource, params) => {
    if (!params.filter.network_code || !params.filter.on_air_date) {
      return {
        data: [],
        total: 0,
      };
    }

    var queryArr = [
      { key: "network_code", value: params.filter.network_code },
      { key: "on_air_date", value: params.filter.on_air_date },
    ];

    //programme_id
    if (params.filter.programme_no) {
      queryArr.push({ key: "programme_no", value: parseInt(params.filter.programme_no) });
    }

    const queryString = queryArr.map((item) => `${item.key}=${item.value}`).join("&");

    const url = `${apiUrl}/traffic-log?${queryString}`;
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json),
      total: json.length,
    };
  },

  getListChannelLinkToVerticalMode: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var queryArr = [];

    //Name
    if (params.filter.name) {
      queryArr.push({
        name: {
          $regex: params.filter.name,
          $options: "i",
        },
      });
    }

    //Vertical Mode ID
    if (params.filter.id) {
      queryArr.push({
        $expr: {
          $regexMatch: {
            input: { $toString: `$_id` },
            regex: ".*" + _.escapeRegExp(params.filter.id) + ".*",
            options: "i",
          },
        },
      });
    }

    //Horitontal Channel No
    if (params.filter.horizontal_channel_no) {
      queryArr.push({ horizontal_channel_no: parseInt(params.filter.horizontal_channel_no) });
    }

    //Vertical Channel No
    if (params.filter.vertical_channel_no) {
      queryArr.push({ vertical_channel_no: parseInt(params.filter.vertical_channel_no) });
    }

    if (params.filter.status) {
      queryArr.push({ status: params.filter.status });
    }

    if (queryArr.length > 0) {
      queryObj.where = { $and: queryArr };
    }
    const url = `${apiUrl}/toggleable-schedule?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    for (const item of json.data) {
      item.status = getIMStatus(item.start_time, item.end_time);
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  createChannelLinkToVerticalMode: async (resource, params) => {
    const data = {
      name: params.data.name,
      horizontal_channel_no: parseInt(params.data.horizontal_channel_no),
      vertical_channel_no: parseInt(params.data.vertical_channel_no),
      start_time: params.data.start_time,
      end_time: params.data.end_time,
    };

    const url = `${apiUrl}/toggleable-schedule`;
    const { json } = await httpClient(url, {
      method: "POST",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getOneTrafficLog: async (resource, params) => {
    const url = `${apiUrl}/traffic-log/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json) {
      //Convert _id to id
      data = convert_IdToId(json);
    }

    return {
      data: data,
    };
  },

  getOneChannelLinkToVerticalMode: async (resource, params) => {
    const url = `${apiUrl}/toggleable-schedule/${params.id}`;
    const { json } = await httpClient(url, {
      headers: await getAuthHeaders(),
    });

    var data = null;
    if (json) {
      //Convert _id to id
      data = convert_IdToId(json);

      //Add status for convinient
      data.status = getIMStatus(data.start_time, data.end_time);
    }

    return {
      data: data,
    };
  },

  updateTrafficLog: async (resource, params) => {
    const data = {
      dfn: params.data.dfn,
      seg_no: parseInt(params.data.seg_no),
    };

    const url = `${apiUrl}/traffic-log/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  updateChannelLinkToVerticalMode: async (resource, params) => {
    const data = {
      name: params.data.name,
      horizontal_channel_no: parseInt(params.data.horizontal_channel_no),
      vertical_channel_no: parseInt(params.data.vertical_channel_no),
      start_time: params.data.start_time,
      end_time: params.data.end_time,
    };

    // if (params.data.status != "end") {
    //   data["start_time"] = params.data.start_time;
    //   data["end_time"] = params.data.end_time;
    // }

    const url = `${apiUrl}/toggleable-schedule/${params.id}`;
    const { json } = await httpClient(url, {
      method: "PUT",
      headers: await getAuthHeaders(),
      body: JSON.stringify(data),
    });

    return {
      data: convert_IdToId(json),
    };
  },

  getListIMChatrooms: async (resource, params) => {
    const { page, perPage } = params.pagination;

    const { field, order } = params.sort;
    const queryObj = {
      sort: (order === "DESC" ? "-" : "") + (field === "id" ? "_" : "") + field,
      page: page,
      limit: perPage,
    };

    var queryArr = [];

    if (params.filter.name) {
      queryArr.push({
        name: {
          $regex: params.filter.name,
          $options: "i",
        },
      });
      // query["name"] = {
      //   $regex: params.filter.name,
      //   $options: "i",
      // };
    }
    if (params.filter.id) {
      queryArr.push({
        $expr: {
          $regexMatch: {
            input: { $toString: `$_id` },
            regex: ".*" + _.escapeRegExp(params.filter.id) + ".*",
            options: "i",
          },
        },
      });
    }
    if (params.filter.channel_no) {
      queryArr.push({ channel_no: parseInt(params.filter.channel_no) });
      // query["channel_no"] = parseInt(params.filter.channel_no);
    }
    if (params.filter.status) {
      queryArr.push({ status: params.filter.status });
      // query["status"] = params.filter.status;
    }

    if (queryArr.length > 0) {
      queryObj.where = { $and: queryArr };
    }
    const url = `${apiUrl}/im-rooms?query=` + JSON.stringify(queryObj);
    var { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    //Get all icon pack types
    const { data: iconPackTypes } = await dataProvider.getIconPackTypes();

    let uniquePackIds = new Set();

    for (const item of json.data) {
      item.status = getIMStatus(item.start_time, item.end_time);

      if (item.canned_message_list) {
        for (const d of item.canned_message_list) {
          d.status = getIMStatus(d.start_time, d.end_time);
          d.voting_enabled = d.list_type == "vote";
        }
      }

      //Backward compatible to type = String
      if (Array.isArray(item.channel_no)) {
        item.channel_no = item.channel_no.join(",");
      }

      //Get all icon
      //Each im-room should have only one icon_list, Move icon_list to anothe variable
      if (item.icon_list && item.icon_list.length > 0) {
        var iconList = item.icon_list[0];

        item["icons"] = iconList.icons;
        item["icon_list_id"] = iconList.id;

        for (const icon of iconList.icons) {
          //Note: Backward compatible for old icon without type field, assign them to "free" type
          if (!icon.type) {
            icon.type = iconPackTypes.find((pack) => !pack.is_pay).id;
          }

          //Assign type_name to icon
          icon.type_name = iconPackTypes.find((pack) => pack.id == icon.type)?.name || "";
        }

        //Gather all unique pack_ids
        for (const icon of item["icons"]) {
          if (icon.pack_id) {
            uniquePackIds.add(icon.pack_id);
          }
        }
      }
    }

    //Get Paid Icon pack names
    if (uniquePackIds.size > 0) {
      const { data: paidIconPacks } = await dataProvider.getPaidIconPackByIds([...uniquePackIds]);

      //Assign pack_name to paid icon
      for (const item of json.data) {
        if (item.icons) {
          for (const icon of item.icons) {
            if (icon.pack_id) {
              icon.pack_name = paidIconPacks.find((pack) => pack.id == icon.pack_id)?.name || "";
            }
          }
        }
      }
    }

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },

  searchCannedMessagesByKeyword: async (params) => {
    if (Object.keys(params.filter).length == 0) {
      return { data: [], total: 0 };
    }

    //NOTE: Ignore, when create new item from autocomplete, it will create a API request with text '@@ra-create'. weird
    if (params.filter.text == "@@ra-create") {
      return { data: [], total: 0 };
    }

    var query = {
      page: 1,
      limit: 999999,
      where: {
        text: {
          $regex: params.filter.text,
          $options: "i",
        },
      },
    };

    const url = `${apiUrl}/im-canned-messages?query=` + JSON.stringify(query);

    const { json } = await httpClient(url, {
      method: "GET",
      headers: await getAuthHeaders(),
    });

    return {
      data: convert_IdToId(json.data),
      total: json.total,
    };
  },
};

function translatePlatformArray(arr) {
  if (arr.length == 0) return "n/a";
  return arr
    .map((item) => {
      return translatePlatform(item);
    })
    .join(", ");
}

function translatePlatform(text) {
  switch (text) {
    case "ios":
      return "iOS";
    case "android":
      return "Android";
    case "web":
      return "Web";
    case "stb":
      return "STB";
    case "android_tv":
      return "Android TV";
    case "samsung_tv":
      return "Samsung TV";
    case "lg_tv":
      return "LG TV";
    default:
      return text;
  }
}

export default dataProvider;
